import {
  Box,
  Button,
  Divider,
  IconButton,
  //   ButtonGroup,
  Grid,
  InputAdornment,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import AlertMessages from "common/Alert/AlertMessages";
import { useSnackbar } from "notistack";
import SimpleModal from "common/Form/Form";
import { useNavigate, useParams } from "react-router-dom";
import ComponentHeaderTwo from "common/ComponentHeaderTwo/ComponentHeaderTwo";
import { ReactComponent as Items } from "assets/SideBarIcons/items.svg";
import { checkPrivileges } from "Helpers/CheckPrivileges";
import { useBusinessSetupEntityBreadcrumbs } from "Helpers/useBusinessSetupEntityBreadcrumbs";
import { useEffect, useMemo, useRef, useState } from "react";
import { GetItemByIdResponse } from "subModule/src/services/items/interface";
import Loader from "layout/Loader";
import DynamicSelect from "common/Select/Select";
import {
  ItemsProfileService,
  TaxProcedureProfileService,
  RackProfileService,
} from "subModule/src/core/services";
import { normalizeBinsList } from "subModule/src/services/rack/service";
import { isBinInventoryMode } from "pages/Store/Racks/rackUtils";
import { useSelector } from "react-redux";
import { selectUserInfo } from "features/user/userSlice";
import { useGetManufacturerDropdownService } from "subModule/src/services/manufacturer/useManufacturer";
import { useGetUnitsDropdownService } from "subModule/src/services/units/useUnits";
import CommonCheckbox from "common/CheckBox/Checkbox";
import ItemTabs from "./ItemTabs";
import { useGetItemGroupDropdownService } from "subModule/src/services/itemgroup/useItemGroup";
import FormDialog from "common/Modal/Modal";
import ItemGroupModal from "pages/ItemGroup/ItemGroupModal";
import { ReactComponent as ModalBtn } from "assets/Modal/ModalBtn.svg";
import { useGetTaxProcedureDropdownService } from "subModule/src/services/taxProcedure/useTaxProcedure";
import Currency from "common/Others/Currency";
import { useGetItemsDropdownService } from "subModule/src/services/items/useItems";
import { useGetStoreDropdownService } from "subModule/src/services/store/useStore";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import DocumentScannerOutlinedIcon from "@mui/icons-material/DocumentScannerOutlined";
import InfoIcon from "@mui/icons-material/Info";
import { BarcodeScanner } from "react-barcode-scanner";
import { BarcodeDetectorPolyfill } from "@preflower/barcode-detector-polyfill";
import "react-barcode-scanner/polyfill";
import { GetDefaultTaxProcedureResponse } from "subModule/src/services/taxProcedure/interface";
import { themes } from "theme/themes";
import { brandingInfo } from "features/server/brandingSlice";
// import { useGetVendorService } from "@subModule/src/services/vendor/useVendor";
// import RemoveIcon from "@mui/icons-material/Remove";
import { useGetVendorService } from "subModule/src/services/vendor/useVendor";
import { useGetServicesDropdownService } from "subModule/src/services/service/useService";
import { useGetItemCategoryDropdownService } from "subModule/src/services/itemcategory/useItemCategory";
import UnitModal from "pages/Units/UnitModal";
import ManufacturersModal from "pages/Manufacturer/ManufacturersModal";
import SupplierModal from "pages/Supplier/SupplierModal";
import {
  TYRE_APPLICATION_OPTIONS,
  TYRE_ASPECT_RATIO_OPTIONS,
  TYRE_BRAND_OPTIONS,
  TYRE_LOAD_INDEX_OPTIONS,
  TYRE_RIM_OPTIONS,
  TYRE_RUN_FLAT_OPTIONS,
  TYRE_SPEED_RATING_OPTIONS,
  TYRE_WIDTH_OPTIONS,
  TYRE_XL_REINFORCED_OPTIONS,
  buildTyrePartNo,
  buildTyreSize,
  getTyreDescriptionValue,
  isTyreReplacementCategory,
} from "./tyreItemOptions";
import {
  isEngineOilCategory,
  translateItemCategoryTitle,
} from "./itemCategoryTranslations";

interface FormData {
  [key: string]: any;
}

interface StoreItem {
  id?: number;
  storeId: {
    value: number;
    label: string;
    inventoryMode?: number | null;
  } | null;
  binId: { value: number; label: string } | null;
  itemCost: string;
  stockQuantity: number;
  stockReferenceNumber: string;
}

const BARCODE_FORMATS = [
  "code_128",
  "code_39",
  "code_93",
  "codabar",
  "ean_13",
  "ean_8",
  "itf",
  "upc_a",
  "upc_e",
];

const detectBarcodeFromImage = async (img: HTMLImageElement) => {
  const detector = new BarcodeDetectorPolyfill({ formats: BARCODE_FORMATS });
  for (const scale of [3, 2, 4, 1]) {
    const canvas = document.createElement("canvas");
    canvas.width = img.naturalWidth * scale;
    canvas.height = img.naturalHeight * scale;
    const ctx = canvas.getContext("2d")!;
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.imageSmoothingEnabled = false;
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    const barcodes = await detector.detect(canvas);
    if (barcodes.length) return barcodes;
  }
  return [];
};
export default function ItemsModal() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const debounceTimer = useRef<NodeJS.Timeout | null>(null);
  const { enqueueSnackbar } = useSnackbar();
  const branding = useSelector(brandingInfo);
  const themeColors =
    branding?.attributes?.themeId === 100
      ? branding?.attributes?.customTheme
      : (themes as any)[branding?.attributes?.themeId || 3];
  const {
    register,
    control,
    handleSubmit,
    formState: { errors, dirtyFields, isDirty },
    reset,
    setValue,
    watch,
  } = useForm<FormData>({
    defaultValues: {
      stockQuantity: 1,
      sellBelowCost: false,
      category: { value: 2, label: t("inventoryItem") },
    },
  });
  const [loading, setLoading] = useState<boolean>(params?.id ? true : false);
  const [IsBtnEnabled, setIsBtnEnabled] = useState<boolean>(
    params?.id ? false : true,
  );
  const { breadcrumbItems, captureLabel } = useBusinessSetupEntityBreadcrumbs({
    sectionLabelKey: "Items",
    moduleLabelKey: "items",
    moduleHref: "/parts",
    entityFallbackLabelKey: "title",
    isEdit: !!params?.id,
  });
  const [addNew, setAddNew] = useState<string>("");
  const [prevFormData, setPrevFormData] = useState<any>({});
  const [dropdownSearchTerm, setDropdownSearchTerm] = useState<any>("");
  const [pageNo, setPageNo] = useState<number>(1);
  const [searchLoading, setSearchLoading] = useState<string | null>(null);
  const [barcodeScannerOpen, setBarcodeScannerOpen] = useState(false);
  const [barcodeCameraFacing, setBarcodeCameraFacing] = useState<
    "environment" | "user"
  >("user");
  const barcodeImageRef = useRef<HTMLInputElement>(null);
  const [storeItems, setStoreItems] = useState<
    {
      id: number; // Add id to track items
      storeId: {
        value: number;
        label: string;
        inventoryMode?: number | null;
      } | null;
      binId: { value: number; label: string } | null;
      itemCost: string;
      stockQuantity: number;
      stockReferenceNumber: string;
    }[]
  >(() => {
    if (!params?.id) {
      return [
        {
          id: Date.now(),
          storeId: null,
          binId: null,
          itemCost: "",
          stockQuantity: 1,
          stockReferenceNumber: "",
        },
      ];
    }
    return [];
  });
  const [binsByStoreId, setBinsByStoreId] = useState<
    Record<number, { value: number; label: string }[]>
  >({});

  const loggedInUserData = useSelector(selectUserInfo);
  const primaryLanguage = loggedInUserData?.business?.primaryLanguage;
  const secondaryLanguage = loggedInUserData?.business?.secondaryLanguage;
  const isArabicLanguage = (lang?: string) => {
    const l = (lang || "").toLowerCase();
    return l === "arabic" || l === "ar" || l.includes("arab");
  };
  const localizedItemNamePlaceholder = (lang?: string) =>
    isArabicLanguage(lang) ? t("phItemNameAr") : t("phItemNameEn");
  const loggedInUserCurrency = loggedInUserData?.business?.currency;
  const defaultPriceList = loggedInUserData?.business?.priceListTitle;
  const { data: manufacturersData, refetch: manufacturersRefetch } =
    useGetManufacturerDropdownService({
      pageNumber: pageNo,
      size: 50,
      title: dropdownSearchTerm,
    });
  const { data: unitsData, refetch: unitsRefetch } = useGetUnitsDropdownService(
    { pageNumber: pageNo, size: 50, title: dropdownSearchTerm },
  );
  const { data: itemGroupsData, refetch: itemGroupsRefetch } =
    useGetItemGroupDropdownService({
      pageNumber: pageNo,
      size: 50,
      title: dropdownSearchTerm,
    });
  const { data: taxProceduresData, refetch: taxProceduresRefetch } =
    useGetTaxProcedureDropdownService({
      pageNumber: pageNo,
      size: 50,
      title: dropdownSearchTerm,
    });
  const { data: scrapItemsData, refetch: scrapItemsRefetch } =
    useGetItemsDropdownService(
      { pageNumber: pageNo, size: 50, title: dropdownSearchTerm },
      loggedInUserData?.business?.scrapItemGroupId,
    );
  const { data: storesData, refetch: storesRefetch } =
    useGetStoreDropdownService({
      pageNumber: pageNo,
      size: 50,
      title: dropdownSearchTerm,
    });
  const { data: servicesData, refetch: servicesRefetch } =
    useGetServicesDropdownService({
      pageNumber: pageNo,
      size: 50,
      title: dropdownSearchTerm,
    });
  const { data: itemCategoriesData, refetch: itemCategoriesRefetch } =
    useGetItemCategoryDropdownService({
      pageNumber: pageNo,
      size: 50,
      title: dropdownSearchTerm,
    });
  const manufacturers = (manufacturersData?.pages[0]?.data?.content || []).map(
    (item: { id?: number; title?: string }) => ({
      value: item.id,
      label: item.title,
    }),
  );
  const units = (unitsData?.pages[0]?.data?.content || []).map(
    (item?: { id: number; unitTitle: string }) => ({
      value: item?.id,
      label: item?.unitTitle,
    }),
  );
  const itemGroups = (itemGroupsData?.pages[0]?.data?.content || []).map(
    (item: { id?: number; title?: string; default?: boolean }) => ({
      value: item.id,
      label: item.title,
      isDisabled: watch("category")?.value === 2 && item.default === true,
    }),
  );
  const taxProcedures = (taxProceduresData?.pages[0]?.data?.content || []).map(
    (item: { id: number; title: string; percentageValue?: number }) => ({
      value: item.id,
      label: item.title,
      percentageValue: item.percentageValue,
    }),
  );
  const scrapItems = (scrapItemsData?.pages[0]?.data?.content || []).map(
    (item: { id?: number; title?: string }) => ({
      value: item.id,
      label: item.title,
    }),
  );
  const stores = (storesData?.pages[0]?.data?.content || []).map(
    (item: { id: number; title: string; inventoryMode?: number | null }) => ({
      value: item.id,
      label: item.title,
      inventoryMode: item.inventoryMode ?? null,
    }),
  );
  const warrantyServices = (servicesData?.pages[0]?.data?.content || []).map(
    (item: { id?: number; title?: string }) => ({
      value: item.id,
      label: item.title,
    }),
  );
  const itemCategories = (
    itemCategoriesData?.pages[0]?.data?.content || []
  ).map((item: { id?: number; title?: string }) => ({
    value: item.id,
    title: item.title,
    label: translateItemCategoryTitle(item.title, t),
  }));

  useEffect(() => {
    const current = watch("itemCategory");
    if (!current?.value) return;
    const matched = itemCategories.find((c) => c.value === current.value);
    const originalTitle = matched?.title || current.title;
    const translated = translateItemCategoryTitle(
      originalTitle || current.label,
      t,
    );
    if (
      translated &&
      (translated !== current.label || originalTitle !== current.title)
    ) {
      setValue("itemCategory", {
        ...current,
        title: originalTitle,
        label: translated,
      });
    }
  }, [i18n.language, itemCategoriesData, t]);

  const shippingMethods = [
    { value: 1, label: t("Air") },
    { value: 2, label: t("Sea") },
    { value: 3, label: t("Ground") },
  ];
  const brandOptions = [
    { value: "ACD", label: "ACDELCO" },
    { value: "ADN", label: "ADNOC" },
    { value: "BMW", label: "BMW" },
    { value: "BP", label: "BP" },
    { value: "CAL", label: "Caltex" },
    { value: "CAS", label: "CASTROL" },
    { value: "CHE", label: "CHEVRON" },
    { value: "ELF", label: "ELF" },
    { value: "EMA", label: "Emarat" },
    { value: "ENO", label: "ENOC" },
    { value: "EPP", label: "EPPCO" },
    { value: "FUC", label: "FUCHS" },
    { value: "FUSO", label: "FUSO" },
    { value: "DUF", label: "DUF - Dufe Lube" },
    { value: "GUL", label: "GULF" },
    { value: "HYU", label: "Hyundai" },
    { value: "KIA", label: "KIA" },
    { value: "LEX", label: "Lexus" },
    { value: "LIQ", label: "Liqui Moly" },
    { value: "MER", label: "Mercedes-Benz" },
    { value: "MOB", label: "MOBIL" },
    { value: "MOT", label: "MOTUL" },
    { value: "NIS", label: "Nissan" },
    { value: "OMA", label: "Oman Oil" },
    { value: "PET", label: "Petromin" },
    { value: "PET", label: "PETRONAS" },
    { value: "RAV", label: "Ravenol" },
    { value: "REP", label: "Repsol" },
    { value: "SHE", label: "SHELL" },
    { value: "TOT", label: "TOTAL" },
    { value: "TOY", label: "TOYOTA" },
    { value: "VAL", label: "VALVOLINE" },
  ];
  const gradeOptions = [
    "0W8",
    "0W12",
    "0W16",
    "0W20",
    "0W30",
    "0W40",
    "5W20",
    "5W30",
    "5W40",
    "5W50",
    "10W30",
    "10W40",
    "10W50",
    "10W60",
    "15W40",
    "15W50",
    "20W50",
    "25W60",
  ].map((v) => ({ value: v, label: v }));
  const oilTypeOptions = [
    { value: "FS", label: t("fullSynthetic") },
    { value: "SS", label: t("semiSynthetic") },
    { value: "M", label: t("Mineral") },
  ];
  const applicationOptions = [
    { value: "PET", label: t("PETROL") },
    { value: "DSL", label: t("DIESEL") },
    { value: "HYB", label: t("Hybrid") },
    { value: "HM", label: t("highMileage") },
    { value: "EURO", label: t("euroLowSAPS") },
    { value: "RACE", label: t("Racing") },
    { value: "GAS", label: t("Gas") },
  ];
  const syncOilItemCode = (next: {
    brand?: any;
    grade?: any;
    oilType?: any;
    application?: any;
  }) => {
    const brand = next.brand !== undefined ? next.brand : watch("brand");
    const grade = next.grade !== undefined ? next.grade : watch("grade");
    const oilType =
      next.oilType !== undefined ? next.oilType : watch("oilType");
    const application =
      next.application !== undefined ? next.application : watch("application");
    setValue(
      "itemCode",
      [brand?.value, grade?.value, oilType?.value, application?.value]
        .filter(Boolean)
        .join(" "),
      { shouldValidate: true, shouldDirty: true },
    );
  };
  const syncTyreItemCode = (
    next: {
      brand?: any;
      tyreWidth?: any;
      tyreAspectRatio?: any;
      tyreRim?: any;
    } = {},
  ) => {
    const brand = next.brand !== undefined ? next.brand : watch("brand");
    const tyreWidth =
      next.tyreWidth !== undefined ? next.tyreWidth : watch("tyreWidth");
    const tyreAspectRatio =
      next.tyreAspectRatio !== undefined
        ? next.tyreAspectRatio
        : watch("tyreAspectRatio");
    const tyreRim =
      next.tyreRim !== undefined ? next.tyreRim : watch("tyreRim");
    const itemCode = buildTyrePartNo(
      brand?.value,
      tyreWidth?.value,
      tyreAspectRatio?.value,
      tyreRim?.value,
    );
    if (itemCode) {
      setValue("itemCode", itemCode, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };
  const clearCategoryExtraFields = () => {
    setValue("brand", null);
    setValue("grade", null);
    setValue("oilType", null);
    setValue("application", null);
    setValue("tyreWidth", null);
    setValue("tyreAspectRatio", null);
    setValue("tyreRim", null);
    setValue("loadIndex", null);
    setValue("speedRating", null);
    setValue("xlReinforced", null);
    setValue("runFlat", null);
    setValue("dot", "");
  };
  const currencyOptions = Currency.map((item) => ({
    value: item.value,
    label: item.title,
    symbol: item.symbol,
  }));
  const currencyLabel =
    currencyOptions.find((option: any) => option.value === loggedInUserCurrency)
      ?.symbol || "";

  const { data: vendorsData, refetch: vendorsRefetch } = useGetVendorService({
    pageNumber: pageNo,
    size: 50,
    title: dropdownSearchTerm,
  });

  const supplierOptions = (vendorsData?.pages[0]?.data?.content || []).map(
    (item: { id: number; title: string }) => ({
      value: item.id,
      label: item.title,
    }),
  );
  const categories = useMemo(
    () => [
      { value: 1, label: t("fixedAsset") },
      { value: 2, label: t("inventoryItem") },
      { value: 3, label: t("spotPurchaseItem") },
    ],
    [t, i18n.language],
  );

  useEffect(() => {
    const current = watch("category");
    if (!current?.value) return;
    const updated = categories.find((c) => c.value === current.value);
    if (updated && updated.label !== current.label) {
      setValue("category", updated);
    }
  }, [categories, i18n.language]);

  const getAvailableStores = (currentIndex: number) => {
    const currentItems = (watch("storeItems") as StoreItem[]) || [];
    const selectedStoreIds = currentItems
      .filter((_, idx) => idx !== currentIndex) // Exclude current item
      .map((item) => item.storeId?.value)
      .filter(Boolean); // Remove null/undefined values

    return stores.filter((store) => !selectedStoreIds.includes(store.value));
  };

  const loadBinsForStore = (storeId: number) => {
    if (!storeId) return;
    setSearchLoading(`bins-${storeId}`);
    RackProfileService.getBinsByStore(storeId)
      .then((res: any) => {
        const list = normalizeBinsList(res);
        setBinsByStoreId((prev) => ({
          ...prev,
          [storeId]: list.map((bin) => ({
            value: bin.id,
            label: bin.locationCode || String(bin.id),
          })),
        }));
      })
      .catch((err: any) => {
        console.error("===", err);
        setBinsByStoreId((prev) => ({ ...prev, [storeId]: [] }));
      })
      .finally(() => setSearchLoading(null));
  };

  const handleStoreSelect = (index: number, selectedOption: any) => {
    setValue(`storeItems[${index}].storeId`, selectedOption);
    setValue(`storeItems[${index}].binId`, null);
    setValue("storeItems", [...(watch("storeItems") || [])]);
    if (!selectedOption?.value) {
      setValue(`storeItems[${index}].itemCost`, "");
      setValue(`storeItems[${index}].stockQuantity`, "");
    } else if (isBinInventoryMode(selectedOption?.inventoryMode)) {
      loadBinsForStore(selectedOption.value);
    }
    if (!IsBtnEnabled) setIsBtnEnabled(true);
  };

  useEffect(() => {
    manufacturersRefetch();
    unitsRefetch();
    itemGroupsRefetch();
    taxProceduresRefetch();
    scrapItemsRefetch();
    storesRefetch();
    vendorsRefetch();
    servicesRefetch();
    itemCategoriesRefetch();
    if (!params?.id) {
      getDefaultTaxForPrice();
      getDefaultTaxForCost();
    }
  }, []);

  useEffect(() => {
    if (params?.id && unitsData && itemGroupsData && storesData) {
      if (loading) getByID();
    }
  }, [params, unitsData, itemGroupsData, storesData]);

  useEffect(() => {
    if (isDirty && params?.id) setIsBtnEnabled(true);
  }, [isDirty, dirtyFields]);
  const getDefaultTaxForPrice = () => {
    TaxProcedureProfileService.getActiveDefaultTaxProcedure(2)
      .then((res: GetDefaultTaxProcedureResponse) => {
        if (res.success) {
          setValue("taxProcedureId", {
            value: res.data?.id,
            label: res.data?.title,
            percentageValue: res.data?.percentageValue,
          });
          setValue(
            "taxValue",
            (
              watch("price") *
              ((res?.data?.percentageValue || 0) / 100)
            )?.toFixed(2),
          );
          setValue(
            "priceWithTax",
            parseFloat(watch("price")) +
              watch("price") * ((res?.data?.percentageValue || 0) / 100),
          );
        }
      })
      .catch((err: any) => {
        console.error("===", err);
      })
      .finally(() => setLoading(false));
  };
  const getDefaultTaxForCost = () => {
    TaxProcedureProfileService.getActiveDefaultTaxProcedure(3)
      .then((res: GetDefaultTaxProcedureResponse) => {
        if (res.success) {
          setValue("costTaxProcedureId", {
            value: res.data?.id,
            label: res.data?.title,
            percentageValue: res.data?.percentageValue,
          });
        }
      })
      .catch((err: any) => {
        console.error("===", err);
      })
      .finally(() => setLoading(false));
  };

  const updatePriceTaxFromAmount = (
    price: number | string,
    opts?: { skipPriceWithTax?: boolean },
  ) => {
    const priceNum = parseFloat(String(price)) || 0;
    const taxPct = watch("taxProcedureId")?.percentageValue || 0;
    if (!opts?.skipPriceWithTax) {
      setValue(
        "priceWithTax",
        (priceNum + (priceNum * parseFloat(String(taxPct))) / 100)?.toFixed(2),
      );
    }
    setValue("taxValue", (priceNum * (taxPct / 100))?.toFixed(2));
  };

  const updateCostTaxFromAmount = (itemCost: number | string) => {
    const costNum = parseFloat(String(itemCost)) || 0;
    const taxPct = watch("costTaxProcedureId")?.percentageValue || 0;
    setValue(
      "costWithTax",
      (costNum + (costNum * parseFloat(String(taxPct))) / 100)?.toFixed(2),
    );
    setValue("costtaxValue", (costNum * (taxPct / 100))?.toFixed(2));
  };

  const formatPricingAmount = (n: number): string | number =>
    n - Math.floor(n) > 0.9 ? Math.round(n) : n?.toFixed(2);

  const syncMarginBasedPricing = (
    from: "cost" | "price" | "margin",
    config: {
      isActive: () => boolean;
      getCost: () => number | string | undefined;
      onCostDerived?: (cost: number) => void;
    },
    value?: number | string,
    opts?: { skipPriceWithTax?: boolean },
  ) => {
    if (!config.isActive()) return;
    const rawMargin = watch("profitMargin");
    const marginEmpty = rawMargin == null || rawMargin === "";
    const cost =
      parseFloat(
        String(
          from === "cost" ? (value ?? config.getCost()) : config.getCost(),
        ),
      ) || 0;

    if (from === "price") {
      const priceNum = parseFloat(String(value ?? watch("price"))) || 0;
      // Important UX: don't write back to the price input while typing.
      // Otherwise rounding/formatting causes the cursor to jump and values to change digit-by-digit.
      updatePriceTaxFromAmount(priceNum, opts);
      if (!marginEmpty) {
        const newMargin = cost > 0 ? (priceNum / cost - 1) * 100 : 0;
        setValue(
          "profitMargin",
          newMargin < 0 || isNaN(newMargin) ? 0 : Number(newMargin.toFixed(2)),
        );
      }
    } else {
      if (from === "cost") {
        config.onCostDerived?.(cost);
      }
      if (!marginEmpty) {
        const factor = 1 + (Number(rawMargin) || 0) / 100;
        const price = formatPricingAmount(cost * factor);
        setValue("price", price);
        updatePriceTaxFromAmount(price);
      }
    }
  };

  const syncSpotPurchasePricing = (
    from: "cost" | "price" | "margin",
    value?: number | string,
    opts?: { skipPriceWithTax?: boolean },
  ) =>
    syncMarginBasedPricing(
      from,
      {
        isActive: () => watch("category")?.value === 3,
        getCost: () => watch("itemCost"),
        onCostDerived: (cost) => updateCostTaxFromAmount(cost),
      },
      value,
      opts,
    );

  const syncInventoryPricing = (
    from: "cost" | "price" | "margin",
    value?: number | string,
    opts?: { skipPriceWithTax?: boolean },
  ) =>
    syncMarginBasedPricing(
      from,
      {
        isActive: () => watch("category")?.value === 2 && !params?.id,
        getCost: () => watch("storeItems")?.[0]?.itemCost,
      },
      value,
      opts,
    );

  const syncPricing = (
    from: "cost" | "price" | "margin",
    value?: number | string,
    opts?: { skipPriceWithTax?: boolean },
  ) => {
    syncSpotPurchasePricing(from, value, opts);
    syncInventoryPricing(from, value, opts);
  };

  const getByID = () => {
    const tryFetch = (attempt = 1) => {
      ItemsProfileService.getItemByID(+(params as any)?.id)
        .then((res: GetItemByIdResponse) => {
          if (res.success) {
            const storeItems = Array.isArray(res?.data?.storeItems)
              ? res?.data?.storeItems.map((item: any) => {
                  const storeMeta = (
                    storesData?.pages[0]?.data?.content || []
                  ).find((s: any) => Number(s.id) === Number(item?.storeId));
                  const inventoryMode =
                    item?.inventoryMode ?? storeMeta?.inventoryMode ?? null;
                  const binOption = item?.binId
                    ? {
                        value: Number(item.binId),
                        label:
                          item.locationCode ||
                          item.binLocationCode ||
                          String(item.binId),
                      }
                    : null;
                  if (
                    item?.storeId &&
                    (isBinInventoryMode(inventoryMode) || item?.binId)
                  ) {
                    loadBinsForStore(Number(item.storeId));
                  }
                  return {
                    id: item?.id || Date.now(),
                    storeId: item?.storeId
                      ? {
                          value: +parseInt(item.storeId),
                          label: item.storeTitle || "",
                          inventoryMode,
                        }
                      : null,
                    binId: binOption,
                    itemCost: item.itemCost?.toString() || "",
                    stockQuantity: +item.stockQuantity || 0,
                    stockReferenceNumber:
                      item.stockReferenceNumber?.toString() || "",
                  };
                })
              : [];

            const tyreDesc = (res.data as any)?.itemDescriptions;
            const isTyreItem = isTyreReplacementCategory({
              label: res?.data?.itemCategoryTitle,
              title: res?.data?.itemCategoryTitle,
            });
            const tyreFormValues =
              isTyreItem && tyreDesc
                ? (() => {
                    const brandVal = getTyreDescriptionValue(tyreDesc, "brand");
                    const widthVal = getTyreDescriptionValue(tyreDesc, "width");
                    const aspectVal = getTyreDescriptionValue(
                      tyreDesc,
                      "aspectRatio",
                      "aspectratio",
                    );
                    const rimVal = getTyreDescriptionValue(tyreDesc, "rim");
                    const loadIndexVal = getTyreDescriptionValue(
                      tyreDesc,
                      "loadIndex",
                      "loadindex",
                    );
                    const speedRatingVal = getTyreDescriptionValue(
                      tyreDesc,
                      "speedRating",
                      "speedrating",
                    );
                    const applicationVal = getTyreDescriptionValue(
                      tyreDesc,
                      "application",
                    );
                    const xlReinforcedVal = getTyreDescriptionValue(
                      tyreDesc,
                      "xlReinforced",
                      "xlreinforced",
                    );
                    const runFlatVal = getTyreDescriptionValue(
                      tyreDesc,
                      "runFlat",
                      "runflat",
                    );
                    const dotVal = getTyreDescriptionValue(tyreDesc, "dot");
                    const toOpt = (val: string) =>
                      val ? { value: String(val), label: String(val) } : null;
                    return {
                      brand:
                        TYRE_BRAND_OPTIONS.find(
                          (o) => o.label === brandVal || o.value === brandVal,
                        ) ||
                        (brandVal
                          ? { value: brandVal, label: brandVal }
                          : null),
                      tyreWidth: toOpt(widthVal),
                      tyreAspectRatio: toOpt(aspectVal),
                      tyreRim: toOpt(rimVal),
                      loadIndex: toOpt(loadIndexVal),
                      speedRating: toOpt(speedRatingVal),
                      application: applicationVal
                        ? TYRE_APPLICATION_OPTIONS.find(
                            (o) =>
                              o.value === applicationVal ||
                              o.label === applicationVal,
                          ) || toOpt(applicationVal)
                        : null,
                      xlReinforced: xlReinforcedVal
                        ? TYRE_XL_REINFORCED_OPTIONS.find(
                            (o) =>
                              o.value === xlReinforcedVal ||
                              o.label === xlReinforcedVal,
                          ) || toOpt(xlReinforcedVal)
                        : null,
                      runFlat: runFlatVal
                        ? TYRE_RUN_FLAT_OPTIONS.find(
                            (o) =>
                              o.value === runFlatVal || o.label === runFlatVal,
                          ) || toOpt(runFlatVal)
                        : null,
                      dot: dotVal || "",
                    };
                  })()
                : {};

            reset({
              ...(res?.data || {}),
              storeItems: storeItems,
              vendorId: res.data?.vendorId
                ? {
                    value: res.data?.vendorId,
                    label: res.data?.vendorName,
                  }
                : null,
              manufacturer: res.data?.manufacturer
                ? {
                    value: res.data?.manufacturer,
                    label: res.data?.manufacturerTitle,
                  }
                : null,
              itemWarrantyServiceId: res.data?.itemWarrantyServiceId
                ? {
                    value: res.data?.itemWarrantyServiceId,
                    label:
                      res?.data?.itemWarrantyServiceTitle ||
                      res.data?.itemWarrantyServiceId,
                  }
                : null,
              unitId: res.data?.unitId
                ? {
                    value: res.data?.unitId,
                    label: res.data?.unitTitle || res.data?.unitId,
                  }
                : null,
              itemGroupId: res.data?.itemGroupId
                ? {
                    value: res.data?.itemGroupId,
                    label: res?.data?.itemGroupTitle || res.data?.itemGroupId,
                  }
                : null,
              itemCategory: res.data?.itemCategory
                ? {
                    value: res.data?.itemCategory,
                    title: res?.data?.itemCategoryTitle,
                    label: translateItemCategoryTitle(
                      res?.data?.itemCategoryTitle ||
                        String(res.data?.itemCategory),
                      t,
                    ),
                  }
                : null,
              taxProcedureId: res.data?.taxProcedureId
                ? {
                    value: res.data?.taxProcedureId,
                    label:
                      res?.data?.taxProcedureTitle || res.data?.taxProcedureId,
                    percentageValue: res?.data?.taxPercentageValue || 0,
                  }
                : null,
              scrapItemId: res.data?.scrapItemId
                ? {
                    value: res.data?.scrapItemId,
                    label: res?.data?.scrapItemTitle || res.data?.scrapItemId,
                  }
                : null,
              storeId: res.data?.storeId
                ? { value: res.data?.storeId, label: res.data?.storeTitle }
                : null,
              shippingMethod: res.data?.shippingMethod
                ? {
                    value: res.data?.shippingMethod,
                    label: shippingMethods.find(
                      (v) => v.value === res.data?.shippingMethod,
                    )?.label,
                  }
                : null,
              stockQuantity: res?.data?.baseItemQuantity || 0,
              taxValue: (
                (res?.data.price || 0) *
                ((res?.data?.taxPercentageValue || 0) / 100)
              )?.toFixed(2),
              category: res?.data?.category
                ? {
                    value: res?.data?.category,
                    label:
                      categories.find((v) => v.value === res?.data.category)
                        ?.label || res.data.category,
                  }
                : null,
              costTaxProcedureId: res.data?.costTaxProcedureId
                ? {
                    value: res.data?.costTaxProcedureId,
                    label:
                      res?.data?.costTaxProcedureTitle ||
                      res.data?.costTaxProcedureId,
                    percentageValue: res?.data?.costTaxPercentageValue || 0,
                  }
                : null,
              costtaxValue: (
                (res?.data.itemCost || 0) *
                ((res?.data?.costTaxPercentageValue || 0) / 100)
              )?.toFixed(2),
              sellBelowCost: !!res.data?.sellBelowCost,
              ...tyreFormValues,
            });

            setStoreItems(storeItems); // Now matches the initial state structure
            setPrevFormData(res?.data || {});
            captureLabel(res?.data?.title);
            setLoading(false);
            if (res.data?.itemCategory === 42 && res.data?.itemCode) {
              const [brandVal, gradeVal, oilTypeVal, applicationVal] = String(
                res.data.itemCode,
              ).split(" ");
              setValue(
                "brand",
                brandVal
                  ? {
                      value: brandVal?.toUpperCase(),
                      label:
                        brandOptions.find(
                          (o) => o.value === brandVal?.toUpperCase(),
                        )?.label || brandVal?.toUpperCase(),
                    }
                  : null,
              );
              setValue(
                "grade",
                gradeVal
                  ? {
                      value: gradeVal?.toUpperCase(),
                      label: gradeVal?.toUpperCase(),
                    }
                  : null,
              );
              setValue(
                "oilType",
                oilTypeVal
                  ? {
                      value: oilTypeVal?.toUpperCase(),
                      label:
                        oilTypeOptions.find((o) => o.value === oilTypeVal)
                          ?.label || oilTypeVal?.toUpperCase(),
                    }
                  : null,
              );
              setValue(
                "application",
                applicationVal
                  ? {
                      value: applicationVal?.toUpperCase(),
                      label:
                        applicationOptions.find(
                          (o) => o.value === applicationVal,
                        )?.label || applicationVal?.toUpperCase(),
                    }
                  : null,
              );
            }
            setValue(
              "priceWithTax",
              parseFloat(watch("price")) + parseFloat(watch("taxValue")),
            );
            setValue(
              "costWithTax",
              parseFloat(watch("itemCost")) + parseFloat(watch("costtaxValue")),
            );
          } else {
            enqueueSnackbar(
              <AlertMessages text={res.message || "Something went wrong"} />,
              { variant: "error" },
            );
          }
        })
        .catch((err: any) => {
          console.error("===", err?.message || "");
          if (attempt < 4) {
            setTimeout(() => tryFetch(attempt + 1), 1000); // retry after 1s
          }
        });
    };
    tryFetch();
  };

  const onSubmit = (data: any) => {
    setIsBtnEnabled(false);
    delete data.taxValue;
    delete data.priceWithTax;
    delete data.tax;
    delete data.costtaxValue;
    delete data.costtax;
    delete data.costWithTax;
    const isTyreCategory = isTyreReplacementCategory(data?.itemCategory);
    // API stores itemDescriptions keys in lowercase (aspectratio, loadindex, …)
    const tyreItemDescriptions = isTyreCategory
      ? {
          brand: data.brand?.label || data.brand?.value || "",
          width: data.tyreWidth?.value || "",
          aspectratio: data.tyreAspectRatio?.value || "",
          rim: data.tyreRim?.value || "",
          tyresize: buildTyreSize(
            data.tyreWidth?.value,
            data.tyreAspectRatio?.value,
            data.tyreRim?.value,
          ),
          loadindex: data.loadIndex?.value || "",
          speedrating: data.speedRating?.value || "",
          application: data.application?.value || data.application?.label || "",
          xlreinforced: data.xlReinforced?.value || "",
          runflat: data.runFlat?.value || "",
          dot: data.dot || "",
        }
      : undefined;
    delete data.grade;
    delete data.oilType;
    delete data.application;
    delete data.brand;
    delete data.tyreWidth;
    delete data.tyreAspectRatio;
    delete data.tyreRim;
    delete data.loadIndex;
    delete data.speedRating;
    delete data.xlReinforced;
    delete data.runFlat;
    delete data.dot;
    if (data?.category?.value !== 3) {
      delete data.itemCost;
      delete data.taxableCost;
      delete data.costTaxProcedureId;
    } else data.itemCost = +data?.itemCost || 0;
    if (data?.category?.value !== 2 && data?.category?.value !== 3) {
      delete data.profitMargin;
      delete data.itemCategory;
      delete data.sellBelowCost;
    } else {
      data.profitMargin = +data?.profitMargin || 0;
      data.sellBelowCost = !!data.sellBelowCost;
    }
    const payloadStoreItems = (data.storeItems || [])
      .map((item: any) => ({
        storeId: item?.storeId?.value || 0,
        itemCost: +item?.itemCost || 0,
        stockQuantity: +item?.stockQuantity || 0,
        stockReferenceNumber: item?.stockReferenceNumber || "",
        ...(item?.binId?.value ? { binId: item.binId.value } : {}),
      }))
      .filter((item: any) => !!item.storeId);
    if (params?.id) {
      ItemsProfileService.updateItems(+params?.id, {
        ...data,
        minQuantity: parseInt(data?.minQuantity) || 0,
        maxQuantity: parseInt(data?.maxQuantity) || 0,
        manufacturer: data?.manufacturer?.value || 0,
        itemWarrantyServiceId: data?.itemWarrantyServiceId?.value || 0,
        unitId: data?.unitId?.value || 0,
        itemGroupId: data?.itemGroupId?.value || 0,
        taxProcedureId:
          data?.taxable && data?.taxProcedureId?.value
            ? data?.taxProcedureId?.value
            : 0,
        vendorId: data?.vendorId?.value || 0,
        itemCategory: data?.itemCategory?.value || null,
        scrapItemId: data?.scrapItemId?.value || 0,
        storeId: data?.storeId?.value || 0,
        shippingMethod: data?.shippingMethod?.value || 0,
        category: data?.category?.value || null,
        storeItems: payloadStoreItems,
        costTaxProcedureId:
          data?.taxableCost && data?.costTaxProcedureId?.value
            ? data?.costTaxProcedureId?.value
            : null,
        ...(tyreItemDescriptions
          ? { itemDescriptions: tyreItemDescriptions }
          : {}),
      })
        .then((response: any) => {
          if (response.success) {
            captureLabel(data?.title);
            getByID();
            enqueueSnackbar(
              <AlertMessages
                statusCode={response.status}
                text={t("Item") + " " + t("updated") + " " + t("successfully")}
              />,
              { variant: "success" },
            );
          } else {
            enqueueSnackbar(<AlertMessages text={t(response?.message)} />, {
              variant: "error",
            });
            setIsBtnEnabled(true);
          }
        })
        .catch((err: any) => {
          console.error("===", err);
          setIsBtnEnabled(true);
          enqueueSnackbar(
            <AlertMessages
              text={
                err?.message || err?.data?.message || "Something went wrong"
              }
            />,
            { variant: "error" },
          );
        });
    } else {
      ItemsProfileService.createItems({
        ...data,
        minQuantity: parseInt(data?.minQuantity) || 0,
        maxQuantity: parseInt(data?.maxQuantity) || 0,
        manufacturer: data?.manufacturer?.value || 0,
        itemWarrantyServiceId: data?.itemWarrantyServiceId?.value || 0,
        unitId: data?.unitId?.value || 0,
        itemGroupId: data?.itemGroupId?.value || 0,
        taxProcedureId:
          data?.taxable && data?.taxProcedureId?.value
            ? data?.taxProcedureId?.value
            : 0,
        scrapItemId: data?.scrapItemId?.value || 0,
        vendorId: data?.vendorId?.value || 0,
        itemCategory: data?.itemCategory?.value || null,
        storeId: data?.storeId?.value || 0,
        shippingMethod: data?.shippingMethod?.value || 0,
        category: data?.category?.value || null,
        storeItems: payloadStoreItems,
        costTaxProcedureId:
          data?.taxableCost && data?.costTaxProcedureId?.value
            ? data?.costTaxProcedureId?.value
            : null,
        ...(tyreItemDescriptions
          ? { itemDescriptions: tyreItemDescriptions }
          : {}),
      })
        .then((response: any) => {
          if (response.success) {
            navigate("/parts");
            enqueueSnackbar(
              <AlertMessages
                statusCode={response.status}
                text={t("Item") + " " + t("created") + " " + t("successfully")}
              />,
              { variant: "success" },
            );
          } else {
            setIsBtnEnabled(true);
            enqueueSnackbar(<AlertMessages text={t(response?.message)} />, {
              variant: "error",
            });
          }
        })
        .catch((err: any) => {
          console.error("===", err);
          setIsBtnEnabled(true);
          enqueueSnackbar(
            <AlertMessages
              text={
                err?.message || err?.data?.message || "Something went wrong"
              }
            />,
            { variant: "error" },
          );
        });
    }
  };

  const handleAddMore = () => {
    const newItem = {
      id: Date.now(),
      storeId: null,
      binId: null,
      itemCost: "",
      stockQuantity: 1,
      stockReferenceNumber: "",
    };

    const currentItems = watch("storeItems") || [];
    setValue("storeItems", [...currentItems, newItem]);

    setStoreItems((prev) => [...prev, newItem]);
  };

  const handleDeleteItem = (index: number) => {
    if (storeItems.length <= 1) return;

    const currentItems: Array<{
      storeId: { value: number; label: string } | null;
      itemCost: string;
      stockQuantity: number;
      stockReferenceNumber: string;
    }> = watch("storeItems") || [];

    const updatedFormItems = currentItems.filter(
      (_: any, i: number) => i !== index,
    );
    setValue("storeItems", updatedFormItems);

    // Update local state
    setStoreItems((prev) => {
      const newItems = [...prev];
      newItems.splice(index, 1);
      return newItems;
    });
  };
  const handleDropdownActions = (
    typeName: string,
    action: "searchIt" | "loadNext",
    search?: string,
  ) => {
    if (action === "searchIt") {
      setPageNo(1);
      setDropdownSearchTerm(search);
      if (search) setSearchLoading(typeName);
    } else {
      setPageNo(pageNo + 1);
      setSearchLoading(typeName);
    }
    if (debounceTimer.current) clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => {
      if (typeName === "itemGroups")
        itemGroupsRefetch().finally(() => setSearchLoading(null));
      else if (typeName === "manufacturers")
        manufacturersRefetch().finally(() => setSearchLoading(null));
      else if (typeName === "taxProcedures" || typeName === "costtaxProcedures")
        taxProceduresRefetch().finally(() => setSearchLoading(null));
      else if (typeName === "units")
        unitsRefetch().finally(() => setSearchLoading(null));
      else if (typeName === "scrapItems")
        scrapItemsRefetch().finally(() => setSearchLoading(null));
      else if (typeName === "stores")
        storesRefetch().finally(() => setSearchLoading(null));
      else if (typeName === "suppliers")
        vendorsRefetch().finally(() => setSearchLoading(null));
      else if (typeName === "warrantyServices")
        servicesRefetch().finally(() => setSearchLoading(null));
      else if (typeName === "itemCategories")
        itemCategoriesRefetch().finally(() => setSearchLoading(null));
    }, 300);
  };
  return (
    <>
      <ComponentHeaderTwo
        showBtn={true}
        showSaveBtn={true}
        onClick={() => navigate("/parts")}
        onSubmit={handleSubmit(onSubmit)}
        heading={params?.id ? t("items") : t("addItems")}
        icon={<Items height={28} width={28} />}
        btnText={"back"}
        btnType={"back"}
        isBtnEnabled={IsBtnEnabled}
        showCreateBtn={checkPrivileges("ROLE_ITEM_CREATE")}
        breadcrumbItems={breadcrumbItems}
      />
      <div className={`${params?.id ? "flex" : ""}`}>
        {params?.id ? <ItemTabs params={params} selectedIndex={0} /> : null}
        {loading ? (
          <Loader />
        ) : (
          <SimpleModal
            visable={true}
            padding={false}
            title={params?.id ? t("items") : t("addItems")}
            isButtonVisable={true}
            isVisableBtn={IsBtnEnabled}
            btnclosetext="Back"
            buttonText={params?.id ? "update" : "submit"}
            attBtnNotshow={false}
            notVisableBackbtn={true}
            showPortList={handleSubmit(onSubmit)}
            formSubmit={handleSubmit(onSubmit)}
            content={
              <>
                <Grid
                  container
                  component="form"
                  id="form"
                  spacing={2}
                  onSubmit={handleSubmit(onSubmit)}
                  // className="px-2"
                >
                  <Grid container spacing={2} className="my-[0px] ml-[3px]">
                    <Grid item xs={12}>
                      <Typography className="flex font-Saira font-[800] text-[19px] text-[#000000]">
                        {t("general")}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Controller
                        name="category"
                        control={control}
                        defaultValue={null}
                        rules={{ required: t("This field is required.") }}
                        render={({ field }) => (
                          <DynamicSelect
                            label={t("category") + " *"}
                            {...field}
                            options={categories}
                            onChange={(selectedOption: any) => {
                              field.onChange(selectedOption);
                              if (selectedOption?.value !== 1)
                                setValue("depreciation", null);
                              if (
                                selectedOption?.value !== 2 &&
                                selectedOption?.value !== 3
                              ) {
                                setValue("profitMargin", null);
                                setValue("itemCategory", null);
                                setValue("brand", null);
                                setValue("grade", null);
                                setValue("oilType", null);
                                setValue("application", null);
                              }
                              if (
                                selectedOption?.value === 1 ||
                                selectedOption?.value === 3
                              ) {
                                setStoreItems([]);
                                setValue("storeItems", []);
                                setValue("itemEveryMile", null);
                                setValue("itemEveryPeriodType", null);
                                setValue("haveScrapItem", false);
                                setValue("scrapItemId", null);
                                setValue("minPrice", null);
                                setValue("minQuantity", 0);
                                setValue("maxQuantity", null);
                                if (selectedOption?.value === 1)
                                  setValue("vendorId", null);
                                setValue("itemSupplierNumber", "");
                                setValue("warrantyMileage", null);
                                setValue("itemWarrantyServiceId", null);
                                setValue("shippingMethod", null);
                                setValue("sellBelowCost", false);
                              }
                              if (selectedOption?.value === 3)
                                setValue("itemGroupId", null);
                            }}
                            error={errors.category?.message as string}
                            isDisabled={
                              (params as any)?.id && prevFormData?.category
                            }
                          />
                        )}
                      />
                    </Grid>
                    {watch("category")?.value === 1 ? (
                      <Grid item xs={12} md={3}>
                        <TextField
                          type="number"
                          {...register("depreciation", {
                            required: t("This field is required."),
                          })}
                          onChange={(e: any) => {
                            const value = e.target.value;
                            e.target.value =
                              value < 0 ? 0 : value > 100 ? 100 : value || "";
                            if (!IsBtnEnabled) setIsBtnEnabled(true);
                          }}
                          label={t("depreciation") + "* (%)"}
                          placeholder={t("depreciation") + "* (%)"}
                          title={t("depreciation") + "* (%)"}
                          fullWidth
                          error={!!errors.depreciation}
                          helperText={errors.depreciation?.message as string}
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                    ) : null}
                    <Grid item xs={12} md={3}>
                      <TextField
                        {...register("itemCode", {
                          validate: {
                            required: (value) =>
                              value?.trim() !== "" ||
                              t("This field is required."),
                          },
                        })}
                        label={
                          <Box className="flex items-center gap-1">
                            {t("itemCode")} *
                            <Tooltip
                              title={t("itemCodeInfo")}
                              enterDelay={0}
                              placement="top"
                              arrow
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor: "#fff",
                                    boxShadow: "0px 2px 8px rgba(0,0,0,0.12)",
                                    fontFamily: "Saira, sans-serif",
                                    color: "#111827",
                                    fontSize: "11px",
                                    fontWeight: "400",
                                    lineHeight: 1.5,
                                    padding: "10px",
                                  },
                                },
                              }}
                            >
                              <InfoIcon
                                sx={{
                                  fontSize: 17,
                                  color: "#6b7280",
                                  cursor: "pointer",
                                }}
                              />
                            </Tooltip>
                          </Box>
                        }
                        placeholder={t("phItemCode")}
                        title={t("itemCode")}
                        fullWidth
                        error={!!errors.itemCode}
                        helperText={
                          isTyreReplacementCategory(watch("itemCategory"))
                            ? t("tyreItemCodeAutoHint")
                            : (errors.itemCode?.message as string)
                        }
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          readOnly:
                            watch("itemCategory")?.value === 42 ||
                            isTyreReplacementCategory(watch("itemCategory")),
                          endAdornment: (
                            <InputAdornment
                              position="end"
                              disablePointerEvents={
                                watch("itemCategory")?.value === 42 ||
                                isTyreReplacementCategory(watch("itemCategory"))
                              }
                            >
                              <Tooltip title={t("barCode")}>
                                <DocumentScannerOutlinedIcon
                                  className="cursor-pointer"
                                  sx={{ color: themeColors?.primary }}
                                  onClick={() => setBarcodeScannerOpen(true)}
                                />
                              </Tooltip>
                            </InputAdornment>
                          ),
                        }}
                      />
                      {barcodeScannerOpen && (
                        <FormDialog
                          open={barcodeScannerOpen}
                          onClose={() => {
                            setBarcodeScannerOpen(false);
                            setBarcodeCameraFacing("user");
                          }}
                          title={t("scanBarcode")}
                          hideActions
                          fullWidth
                          maxWidth="sm"
                          content={
                            <Box>
                              <ToggleButtonGroup
                                exclusive
                                fullWidth
                                value={barcodeCameraFacing}
                                onChange={(_, value) => {
                                  if (value) setBarcodeCameraFacing(value);
                                }}
                                sx={{ mb: 2 }}
                              >
                                <ToggleButton value="environment">
                                  {t("backCamera")}
                                </ToggleButton>
                                <ToggleButton value="user">
                                  {t("frontCamera")}
                                </ToggleButton>
                              </ToggleButtonGroup>
                              <Box
                                sx={{
                                  height: 300,
                                  overflow: "hidden",
                                  borderRadius: 1,
                                  mb: 2,
                                }}
                              >
                                <BarcodeScanner
                                  key={barcodeCameraFacing}
                                  trackConstraints={{
                                    width: { min: 640, ideal: 1280 },
                                    height: { min: 480, ideal: 720 },
                                    facingMode: { exact: barcodeCameraFacing },
                                  }}
                                  options={{
                                    delay: 300,
                                    formats: BARCODE_FORMATS,
                                  }}
                                  onCapture={(barcodes) => {
                                    const value = barcodes[0]?.rawValue;
                                    if (!value) return;
                                    setValue("itemCode", value, {
                                      shouldValidate: true,
                                      shouldDirty: true,
                                    });
                                    if (!IsBtnEnabled) setIsBtnEnabled(true);
                                    setBarcodeScannerOpen(false);
                                  }}
                                />
                              </Box>
                              <input
                                ref={barcodeImageRef}
                                type="file"
                                accept="image/*"
                                hidden
                                onChange={async (e) => {
                                  const file = e.target.files?.[0];
                                  e.target.value = "";
                                  if (!file) return;
                                  try {
                                    const img = document.createElement("img");
                                    const url = URL.createObjectURL(file);
                                    await new Promise<void>(
                                      (resolve, reject) => {
                                        img.onload = () => resolve();
                                        img.onerror = reject;
                                        img.src = url;
                                      },
                                    );
                                    const barcodes =
                                      await detectBarcodeFromImage(img);
                                    URL.revokeObjectURL(url);
                                    const value = barcodes[0]?.rawValue;
                                    if (value) {
                                      setValue("itemCode", value, {
                                        shouldValidate: true,
                                        shouldDirty: true,
                                      });
                                      if (!IsBtnEnabled) setIsBtnEnabled(true);
                                      setBarcodeScannerOpen(false);
                                    } else {
                                      enqueueSnackbar(t("Not Found"), {
                                        variant: "warning",
                                      });
                                    }
                                  } catch {
                                    enqueueSnackbar(t("Not Found"), {
                                      variant: "warning",
                                    });
                                  }
                                }}
                              />
                              <Button
                                variant="outlined"
                                fullWidth
                                onClick={() => barcodeImageRef.current?.click()}
                                sx={{
                                  backgroundColor: themeColors?.primary,
                                  color: "#fff",
                                  borderColor: themeColors?.primary,
                                  "&:hover": {
                                    backgroundColor: themeColors?.primary,
                                    borderColor: themeColors?.primary,
                                    color: "#fff",
                                  },
                                }}
                              >
                                {t("upload")}
                              </Button>
                            </Box>
                          }
                        />
                      )}
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        {...register("title", {
                          validate: {
                            required: (value) =>
                              value?.trim() !== "" ||
                              t("This field is required."),
                          },
                        })}
                        label={`${!primaryLanguage ? t("primary") : ""} ${t("name")} ${primaryLanguage ? ` (${t(primaryLanguage)})` : ""} *`}
                        placeholder={localizedItemNamePlaceholder(
                          primaryLanguage,
                        )}
                        title={`${!primaryLanguage ? t("primary") : ""} ${t("name")} ${primaryLanguage ? ` (${t(primaryLanguage)})` : ""} *`
                          .replace(/\s+/g, " ")
                          .trim()}
                        fullWidth
                        error={!!errors.title}
                        helperText={errors.title?.message as string}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        {...register("secondaryTitle")}
                        label={`${!secondaryLanguage ? t("secondary") : ""} ${t("name")} ${secondaryLanguage ? ` (${t(secondaryLanguage)})` : ""}`}
                        placeholder={localizedItemNamePlaceholder(
                          secondaryLanguage,
                        )}
                        title={`${!secondaryLanguage ? t("secondary") : ""} ${t("name")} ${secondaryLanguage ? ` (${t(secondaryLanguage)})` : ""}`
                          .replace(/\s+/g, " ")
                          .trim()}
                        fullWidth
                        error={!!errors.secondaryTitle}
                        helperText={errors.secondaryTitle?.message as string}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    {watch("category")?.value === 2 ||
                    watch("category")?.value === 3 ? (
                      <Grid item xs={12} md={3}>
                        <Controller
                          name="itemCategory"
                          control={control}
                          defaultValue={null}
                          shouldUnregister
                          rules={{ required: t("This field is required.") }}
                          render={({ field }) => (
                            <DynamicSelect
                              label={t("itemCategory") + " *"}
                              {...field}
                              options={itemCategories}
                              isSearchable
                              isClearable
                              defaultPlaceholder="phSelectPartCategory"
                              onChange={(selectedOption: any) => {
                                field.onChange(selectedOption);
                                // setValue("itemCode", "");
                                clearCategoryExtraFields();
                                if (!IsBtnEnabled) setIsBtnEnabled(true);
                              }}
                              error={errors.itemCategory?.message as string}
                              isLoading={searchLoading === "itemCategories"}
                              onInputChange={(
                                search: string,
                                { action }: { action: string },
                              ) => {
                                if (
                                  action === "input-change" ||
                                  (action !== "set-value" &&
                                    action !== "menu-close" &&
                                    action !== "input-blur")
                                )
                                  handleDropdownActions(
                                    "itemCategories",
                                    "searchIt",
                                    search,
                                  );
                                else if (
                                  action === "input-blur" ||
                                  action === "menu-close"
                                ) {
                                  if (dropdownSearchTerm || pageNo > 1)
                                    handleDropdownActions(
                                      "itemCategories",
                                      "searchIt",
                                      "",
                                    );
                                  else setDropdownSearchTerm("");
                                  setPageNo(1);
                                }
                              }}
                              onMenuScrollToBottom={() => {
                                if (
                                  !(itemCategoriesData?.pages[0]?.data as any)
                                    .last
                                )
                                  handleDropdownActions(
                                    "itemCategories",
                                    "loadNext",
                                  );
                              }}
                              page={pageNo}
                            />
                          )}
                        />
                      </Grid>
                    ) : null}
                    {isEngineOilCategory(watch("itemCategory")) ? (
                      <>
                        <Grid item xs={12} md={3}>
                          <Controller
                            name="brand"
                            control={control}
                            defaultValue={null}
                            shouldUnregister
                            rules={{ required: t("This field is required.") }}
                            render={({ field }) => (
                              <DynamicSelect
                                label={t("brand") + " *"}
                                {...field}
                                options={brandOptions}
                                isSearchable
                                isClearable
                                onChange={(selectedOption: any) => {
                                  field.onChange(selectedOption);
                                  syncOilItemCode({ brand: selectedOption });
                                  if (!IsBtnEnabled) setIsBtnEnabled(true);
                                }}
                                error={errors.brand?.message as string}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Controller
                            name="grade"
                            control={control}
                            defaultValue={null}
                            shouldUnregister
                            rules={{ required: t("This field is required.") }}
                            render={({ field }) => (
                              <DynamicSelect
                                label={t("grade") + " *"}
                                {...field}
                                options={gradeOptions}
                                isSearchable
                                isClearable
                                onChange={(selectedOption: any) => {
                                  field.onChange(selectedOption);
                                  syncOilItemCode({ grade: selectedOption });
                                  if (!IsBtnEnabled) setIsBtnEnabled(true);
                                }}
                                error={errors.grade?.message as string}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Controller
                            name="oilType"
                            control={control}
                            defaultValue={null}
                            shouldUnregister
                            rules={{ required: t("This field is required.") }}
                            render={({ field }) => (
                              <DynamicSelect
                                label={t("oilType") + " *"}
                                {...field}
                                options={oilTypeOptions}
                                isSearchable
                                isClearable
                                onChange={(selectedOption: any) => {
                                  field.onChange(selectedOption);
                                  syncOilItemCode({ oilType: selectedOption });
                                  if (!IsBtnEnabled) setIsBtnEnabled(true);
                                }}
                                error={errors.oilType?.message as string}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Controller
                            name="application"
                            control={control}
                            defaultValue={null}
                            shouldUnregister
                            rules={{ required: t("This field is required.") }}
                            render={({ field }) => (
                              <DynamicSelect
                                label={t("application") + " *"}
                                {...field}
                                options={applicationOptions}
                                isSearchable
                                isClearable
                                onChange={(selectedOption: any) => {
                                  field.onChange(selectedOption);
                                  syncOilItemCode({
                                    application: selectedOption,
                                  });
                                  if (!IsBtnEnabled) setIsBtnEnabled(true);
                                }}
                                error={errors.application?.message as string}
                              />
                            )}
                          />
                        </Grid>
                      </>
                    ) : null}
                    {isTyreReplacementCategory(watch("itemCategory")) ? (
                      <>
                        <Grid item xs={12} md={3}>
                          <Controller
                            name="brand"
                            control={control}
                            defaultValue={null}
                            shouldUnregister
                            rules={{ required: t("This field is required.") }}
                            render={({ field }) => (
                              <DynamicSelect
                                label={t("brand") + " *"}
                                {...field}
                                options={TYRE_BRAND_OPTIONS}
                                isSearchable
                                isClearable
                                onChange={(selectedOption: any) => {
                                  field.onChange(selectedOption);
                                  syncTyreItemCode({ brand: selectedOption });
                                  if (!IsBtnEnabled) setIsBtnEnabled(true);
                                }}
                                error={errors.brand?.message as string}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Controller
                            name="tyreWidth"
                            control={control}
                            defaultValue={null}
                            shouldUnregister
                            rules={{ required: t("This field is required.") }}
                            render={({ field }) => (
                              <DynamicSelect
                                label={t("tyreWidth") + " *"}
                                {...field}
                                options={TYRE_WIDTH_OPTIONS}
                                isSearchable
                                isClearable
                                onChange={(selectedOption: any) => {
                                  field.onChange(selectedOption);
                                  syncTyreItemCode({
                                    tyreWidth: selectedOption,
                                  });
                                  if (!IsBtnEnabled) setIsBtnEnabled(true);
                                }}
                                error={errors.tyreWidth?.message as string}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Controller
                            name="tyreAspectRatio"
                            control={control}
                            defaultValue={null}
                            shouldUnregister
                            rules={{ required: t("This field is required.") }}
                            render={({ field }) => (
                              <DynamicSelect
                                label={t("tyreAspectRatio") + " *"}
                                {...field}
                                options={TYRE_ASPECT_RATIO_OPTIONS}
                                isSearchable
                                isClearable
                                onChange={(selectedOption: any) => {
                                  field.onChange(selectedOption);
                                  syncTyreItemCode({
                                    tyreAspectRatio: selectedOption,
                                  });
                                  if (!IsBtnEnabled) setIsBtnEnabled(true);
                                }}
                                error={
                                  errors.tyreAspectRatio?.message as string
                                }
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Controller
                            name="tyreRim"
                            control={control}
                            defaultValue={null}
                            shouldUnregister
                            rules={{ required: t("This field is required.") }}
                            render={({ field }) => (
                              <DynamicSelect
                                label={t("tyreRim") + " *"}
                                {...field}
                                options={TYRE_RIM_OPTIONS}
                                isSearchable
                                isClearable
                                onChange={(selectedOption: any) => {
                                  field.onChange(selectedOption);
                                  syncTyreItemCode({ tyreRim: selectedOption });
                                  if (!IsBtnEnabled) setIsBtnEnabled(true);
                                }}
                                error={errors.tyreRim?.message as string}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Controller
                            name="loadIndex"
                            control={control}
                            defaultValue={null}
                            shouldUnregister
                            render={({ field }) => (
                              <DynamicSelect
                                label={t("loadIndex")}
                                {...field}
                                options={TYRE_LOAD_INDEX_OPTIONS}
                                isSearchable
                                isClearable
                                onChange={(selectedOption: any) => {
                                  field.onChange(selectedOption);
                                  if (!IsBtnEnabled) setIsBtnEnabled(true);
                                }}
                                error={errors.loadIndex?.message as string}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Controller
                            name="speedRating"
                            control={control}
                            defaultValue={null}
                            shouldUnregister
                            render={({ field }) => (
                              <DynamicSelect
                                label={t("speedRating")}
                                {...field}
                                options={TYRE_SPEED_RATING_OPTIONS}
                                isSearchable
                                isClearable
                                onChange={(selectedOption: any) => {
                                  field.onChange(selectedOption);
                                  if (!IsBtnEnabled) setIsBtnEnabled(true);
                                }}
                                error={errors.speedRating?.message as string}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Controller
                            name="application"
                            control={control}
                            defaultValue={null}
                            shouldUnregister
                            render={({ field }) => (
                              <DynamicSelect
                                label={t("application")}
                                {...field}
                                options={TYRE_APPLICATION_OPTIONS}
                                isSearchable
                                isClearable
                                onChange={(selectedOption: any) => {
                                  field.onChange(selectedOption);
                                  if (!IsBtnEnabled) setIsBtnEnabled(true);
                                }}
                                error={errors.application?.message as string}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Controller
                            name="xlReinforced"
                            control={control}
                            defaultValue={null}
                            shouldUnregister
                            render={({ field }) => (
                              <DynamicSelect
                                label={t("xlReinforced")}
                                {...field}
                                options={TYRE_XL_REINFORCED_OPTIONS}
                                isSearchable
                                isClearable
                                onChange={(selectedOption: any) => {
                                  field.onChange(selectedOption);
                                  if (!IsBtnEnabled) setIsBtnEnabled(true);
                                }}
                                error={errors.xlReinforced?.message as string}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Controller
                            name="runFlat"
                            control={control}
                            defaultValue={null}
                            shouldUnregister
                            render={({ field }) => (
                              <DynamicSelect
                                label={t("runFlat")}
                                {...field}
                                options={TYRE_RUN_FLAT_OPTIONS}
                                isSearchable
                                isClearable
                                onChange={(selectedOption: any) => {
                                  field.onChange(selectedOption);
                                  if (!IsBtnEnabled) setIsBtnEnabled(true);
                                }}
                                error={errors.runFlat?.message as string}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <TextField
                            {...register("dot", {
                              validate: {
                                format: (value) =>
                                  !value ||
                                  /^\d{4}$/.test(String(value).trim()) ||
                                  t("dotWeekYearFormat"),
                              },
                            })}
                            label={t("dot")}
                            placeholder="WWYY"
                            title={t("dot")}
                            fullWidth
                            error={!!errors.dot}
                            helperText={
                              (errors.dot?.message as string) ||
                              t("dotWeekYearHint")
                            }
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => {
                              setValue("dot", e.target.value);
                              if (!IsBtnEnabled) setIsBtnEnabled(true);
                            }}
                          />
                        </Grid>
                      </>
                    ) : null}
                    <Grid
                      item
                      xs={12}
                      md={3}
                      className="grid"
                      sx={{
                        gridTemplateColumns: checkPrivileges(
                          "ROLE_MANUFACTURER_CREATE",
                        )
                          ? "85% 10%"
                          : "100%",
                        "& .addNew path": { fill: themeColors?.primary },
                      }}
                    >
                      <Controller
                        name="manufacturer"
                        control={control}
                        defaultValue={null}
                        rules={{ required: false }}
                        render={({ field }) => (
                          <DynamicSelect
                            label={t("manufacturer")}
                            {...field}
                            options={manufacturers}
                            isSearchable
                            isClearable
                            defaultPlaceholder="phSelectManufacturer"
                            onChange={(selectedOption: any) =>
                              field.onChange(selectedOption)
                            }
                            error={errors.manufacturer?.message as string}
                            isLoading={searchLoading === "manufacturers"}
                            onInputChange={(
                              search: string,
                              { action }: { action: string },
                            ) => {
                              if (
                                action === "input-change" ||
                                (action !== "set-value" &&
                                  action !== "menu-close" &&
                                  action !== "input-blur")
                              )
                                handleDropdownActions(
                                  "manufacturers",
                                  "searchIt",
                                  search,
                                );
                              else if (
                                action === "input-blur" ||
                                action === "menu-close"
                              ) {
                                if (dropdownSearchTerm || pageNo > 1)
                                  handleDropdownActions(
                                    "manufacturers",
                                    "searchIt",
                                    "",
                                  );
                                else setDropdownSearchTerm("");
                                setPageNo(1);
                              }
                            }}
                            onMenuScrollToBottom={() => {
                              if (
                                !(manufacturersData?.pages[0]?.data as any).last
                              )
                                handleDropdownActions(
                                  "manufacturers",
                                  "loadNext",
                                );
                            }}
                            page={pageNo}
                          />
                        )}
                      />
                      {checkPrivileges("ROLE_MANUFACTURER_CREATE") && (
                        <Tooltip
                          onClick={() => setAddNew("manufacturers")}
                          title={t("addManufacturer")}
                        >
                          <ModalBtn className="mt-5 mx-2 mb-2 cursor-pointer h-[38px] addNew" />
                        </Tooltip>
                      )}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={3}
                      className="grid"
                      sx={{
                        gridTemplateColumns:
                          checkPrivileges("ROLE_UNIT_CREATE") &&
                          !prevFormData?.unitId
                            ? "85% 10%"
                            : "100%",
                        "& .addNew path": { fill: themeColors?.primary },
                      }}
                    >
                      <Controller
                        name="unitId"
                        control={control}
                        defaultValue={null}
                        rules={{ required: t("This field is required.") }}
                        render={({ field }) => (
                          <DynamicSelect
                            label={t("baseUnitId") + " *"}
                            {...field}
                            options={units}
                            isSearchable
                            defaultPlaceholder="phBaseUnit"
                            onChange={(selectedOption: any) =>
                              field.onChange(selectedOption)
                            }
                            error={errors.unitId?.message as string}
                            isDisabled={params?.id && prevFormData?.unitId}
                            isLoading={searchLoading === "units"}
                            onInputChange={(
                              search: string,
                              { action }: { action: string },
                            ) => {
                              if (
                                action === "input-change" ||
                                (action !== "set-value" &&
                                  action !== "menu-close" &&
                                  action !== "input-blur")
                              )
                                handleDropdownActions(
                                  "units",
                                  "searchIt",
                                  search,
                                );
                              else if (
                                action === "input-blur" ||
                                action === "menu-close"
                              ) {
                                if (dropdownSearchTerm || pageNo > 1)
                                  handleDropdownActions(
                                    "units",
                                    "searchIt",
                                    "",
                                  );
                                else setDropdownSearchTerm("");
                                setPageNo(1);
                              }
                            }}
                            onMenuScrollToBottom={() => {
                              if (!(unitsData?.pages[0]?.data as any).last)
                                handleDropdownActions("units", "loadNext");
                            }}
                            page={pageNo}
                            description={<Box>{t("baseUnitIdInfo")}</Box>}
                          />
                        )}
                      />
                      {checkPrivileges("ROLE_UNIT_CREATE") &&
                      !prevFormData?.unitId ? (
                        <Tooltip
                          onClick={() => setAddNew("units")}
                          title={t("addBaseUnit")}
                        >
                          <ModalBtn className="mt-5 mx-2 mb-2 cursor-pointer h-[38px] addNew" />
                        </Tooltip>
                      ) : null}
                    </Grid>
                    {watch("category")?.value === 3 ? (
                      <Grid
                        item
                        xs={12}
                        md={3}
                        className="grid"
                        sx={{
                          gridTemplateColumns: checkPrivileges(
                            "ROLE_VENDOR_CREATE",
                          )
                            ? "85% 10%"
                            : "100%",
                          "& .addNew path": { fill: themeColors?.primary },
                        }}
                      >
                        <Controller
                          name="vendorId"
                          control={control}
                          defaultValue={null}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <DynamicSelect
                              label={t("vendors")}
                              {...field}
                              options={supplierOptions}
                              isSearchable
                              isClearable
                              onChange={(selectedOption: any) =>
                                field.onChange(selectedOption)
                              }
                              error={errors.vendorId?.message as string}
                              isLoading={searchLoading === "suppliers"}
                              onInputChange={(
                                search: string,
                                { action }: { action: string },
                              ) => {
                                if (
                                  action === "input-change" ||
                                  (action !== "set-value" &&
                                    action !== "menu-close" &&
                                    action !== "input-blur")
                                )
                                  handleDropdownActions(
                                    "suppliers",
                                    "searchIt",
                                    search,
                                  );
                                else if (
                                  action === "input-blur" ||
                                  action === "menu-close"
                                ) {
                                  if (dropdownSearchTerm || pageNo > 1)
                                    handleDropdownActions(
                                      "suppliers",
                                      "searchIt",
                                      "",
                                    );
                                  else setDropdownSearchTerm("");
                                  setPageNo(1);
                                }
                              }}
                              onMenuScrollToBottom={() => {
                                if (!(vendorsData?.pages[0]?.data as any).last)
                                  handleDropdownActions(
                                    "suppliers",
                                    "loadNext",
                                  );
                              }}
                              page={pageNo}
                            />
                          )}
                        />
                        {checkPrivileges("ROLE_VENDOR_CREATE") && (
                          <Tooltip
                            onClick={() => setAddNew("vendors")}
                            title={t("addVendor")}
                          >
                            <ModalBtn className="mt-5 mx-2 mb-2 cursor-pointer h-[38px] addNew" />
                          </Tooltip>
                        )}
                      </Grid>
                    ) : null}
                  </Grid>
                  <Grid container spacing={2} className="my-[0px] ml-[3px]">
                    {watch("category")?.value === 3 ? null : (
                      <Grid
                        item
                        xs={12}
                        md={3}
                        className="grid"
                        sx={{
                          gridTemplateColumns: checkPrivileges(
                            "ROLE_ITEMGROUP_CREATE",
                          )
                            ? "85% 10%"
                            : "100%",
                          "& .addNew path": { fill: themeColors?.primary },
                        }}
                      >
                        <Controller
                          name="itemGroupId"
                          control={control}
                          defaultValue={null}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <DynamicSelect
                              label={t("itemGroup")}
                              {...field}
                              options={itemGroups}
                              isSearchable
                              isClearable
                              defaultPlaceholder="phSelectPartGroup"
                              onChange={(selectedOption: any) =>
                                field.onChange(selectedOption)
                              }
                              error={errors.itemGroupId?.message as string}
                              isLoading={searchLoading === "itemGroups"}
                              onInputChange={(
                                search: string,
                                { action }: { action: string },
                              ) => {
                                if (
                                  action === "input-change" ||
                                  (action !== "set-value" &&
                                    action !== "menu-close" &&
                                    action !== "input-blur")
                                )
                                  handleDropdownActions(
                                    "itemGroups",
                                    "searchIt",
                                    search,
                                  );
                                else if (
                                  action === "input-blur" ||
                                  action === "menu-close"
                                ) {
                                  if (dropdownSearchTerm || pageNo > 1)
                                    handleDropdownActions(
                                      "itemGroups",
                                      "searchIt",
                                      "",
                                    );
                                  else setDropdownSearchTerm("");
                                  setPageNo(1);
                                }
                              }}
                              onMenuScrollToBottom={() => {
                                if (
                                  !(itemGroupsData?.pages[0]?.data as any).last
                                )
                                  handleDropdownActions(
                                    "itemGroups",
                                    "loadNext",
                                  );
                              }}
                              page={pageNo}
                            />
                          )}
                        />
                        {checkPrivileges("ROLE_ITEMGROUP_CREATE") && (
                          <Tooltip
                            onClick={() => setAddNew("partsGroup")}
                            title={t("addItemGroup")}
                          >
                            <ModalBtn className="mt-5 mx-2 mb-2 cursor-pointer h-[38px] addNew" />
                          </Tooltip>
                        )}
                        {addNew !== "" && (
                          <FormDialog
                            open={addNew !== ""}
                            onClose={(event, reason) =>
                              event && reason !== "backdropClick"
                                ? setAddNew("")
                                : ""
                            }
                            title={
                              addNew === "partsGroup"
                                ? t("addItemGroup")
                                : addNew === "manufacturers"
                                  ? t("addManufacturer")
                                  : addNew === "vendors"
                                    ? t("addVendor")
                                    : t("addBaseUnit")
                            }
                            createPopup={true}
                            fullWidth
                            hideActions={true}
                            content={
                              addNew === "partsGroup" ? (
                                <ItemGroupModal
                                  setAddNew={setAddNew}
                                  refetch={itemGroupsRefetch}
                                />
                              ) : addNew === "manufacturers" ? (
                                <ManufacturersModal
                                  setAddNew={setAddNew}
                                  refetch={manufacturersRefetch}
                                />
                              ) : addNew === "vendors" ? (
                                <SupplierModal
                                  setAddNew={setAddNew}
                                  vendorsRefetch={vendorsRefetch}
                                />
                              ) : (
                                <UnitModal
                                  setAddNew={setAddNew}
                                  refetch={unitsRefetch}
                                />
                              )
                            }
                          />
                        )}
                      </Grid>
                    )}
                    <Grid item xs={12} md={3}>
                      <TextField
                        {...register("partNo")}
                        label={t("partNo")}
                        placeholder={t("phPartNumber")}
                        title={t("partNo")}
                        fullWidth
                        error={!!errors.partNo}
                        helperText={errors.partNo?.message as string}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Controller
                        name="taxable"
                        control={control}
                        defaultValue={false}
                        render={({ field }) => (
                          <CommonCheckbox
                            {...field}
                            label={t("taxable")}
                            onChange={(
                              event: React.ChangeEvent<HTMLInputElement>,
                            ) => {
                              field.onChange(event.target.checked);
                              if (!event.target.checked) {
                                setValue("taxProcedureId", null);
                              }
                              if (!params?.id && event.target.checked)
                                getDefaultTaxForPrice();
                            }}
                            checked={field.value}
                            color={themeColors?.primary}
                          />
                        )}
                      />
                    </Grid>
                    {watch("taxable") ? (
                      <Grid item xs={12} md={3}>
                        <Controller
                          name="taxProcedureId"
                          control={control}
                          defaultValue={null}
                          rules={{ required: t("This field is required.") }}
                          render={({ field }) => (
                            <DynamicSelect
                              label={t("taxProcedure") + " *"}
                              {...field}
                              options={taxProcedures}
                              isSearchable
                              onChange={(selectedOption: any) => {
                                field.onChange(selectedOption);
                                setValue(
                                  "taxValue",
                                  (
                                    watch("price") *
                                    (watch("taxProcedureId")?.percentageValue /
                                      100)
                                  )?.toFixed(2),
                                );
                                setValue(
                                  "priceWithTax",
                                  parseFloat(watch("price")) +
                                    watch("price") *
                                      (selectedOption.percentageValue / 100),
                                );
                              }}
                              error={errors.taxProcedureId?.message as string}
                              isLoading={searchLoading === "taxProcedures"}
                              onInputChange={(
                                search: string,
                                { action }: { action: string },
                              ) => {
                                if (
                                  action === "input-change" ||
                                  (action !== "set-value" &&
                                    action !== "menu-close" &&
                                    action !== "input-blur")
                                )
                                  handleDropdownActions(
                                    "taxProcedures",
                                    "searchIt",
                                    search,
                                  );
                                else if (
                                  action === "input-blur" ||
                                  action === "menu-close"
                                ) {
                                  if (dropdownSearchTerm || pageNo > 1)
                                    handleDropdownActions(
                                      "taxProcedures",
                                      "searchIt",
                                      "",
                                    );
                                  else setDropdownSearchTerm("");
                                  setPageNo(1);
                                }
                              }}
                              onMenuScrollToBottom={() => {
                                if (
                                  !(taxProceduresData?.pages[0]?.data as any)
                                    .last
                                )
                                  handleDropdownActions(
                                    "taxProcedures",
                                    "loadNext",
                                  );
                              }}
                              page={pageNo}
                            />
                          )}
                        />
                      </Grid>
                    ) : null}
                    <Grid item xs={12} md={6}>
                      <TextField
                        {...register("extraNotes")}
                        label={t("description")}
                        placeholder={t("phItemDescription")}
                        title={t("description")}
                        fullWidth
                        error={!!errors.extraNotes}
                        helperText={errors.extraNotes?.message as string}
                        InputLabelProps={{ shrink: true }}
                        multiline
                        rows={1}
                        sx={{
                          "& .MuiInputBase-fullWidth.MuiInputBase-multiline": {
                            width: "100%",
                            paddingRight: "0px",
                            paddingBottom: 0,
                          },
                          "& .MuiInputBase-inputMultiline": {
                            resize: "vertical",
                            minHeight: "78px",
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Divider className="border-[#AEB3C4] border-1 mb-[10px]" />
                      <Box className="flex items-center gap-2">
                        <Typography className="font-Saira font-[800] text-[19px] text-[#000000]">
                          {t(defaultPriceList || "price")}
                        </Typography>
                      </Box>
                    </Grid>
                    {params?.id &&
                    (watch("category")?.value === 2 ||
                      watch("category")?.value === 3) ? (
                      <Grid item xs={12} md={3}>
                        <TextField
                          type="number"
                          label={t("purchaseAverageCost")}
                          placeholder={t("purchaseAverageCost")}
                          title={t("purchaseAverageCost")}
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <span className="font-Saira text-[13px] uppercase">
                                  {loggedInUserCurrency || ""}
                                </span>
                              </InputAdornment>
                            ),
                          }}
                          value={watch("avgItemCost") || 0}
                          disabled={true}
                          sx={{ "& .Mui-disabled": { opacity: 0.6 } }}
                        />
                      </Grid>
                    ) : null}
                    <Grid item xs={12} md={3}>
                      <TextField
                        type="number"
                        {...register("price", {
                          required: t("This field is required."),
                        })}
                        onChange={(e: any) => {
                          const raw = e.target.value;
                          const parsed = parseFloat(raw);
                          const normalized =
                            raw !== "" &&
                            raw !== "." &&
                            !Number.isNaN(parsed) &&
                            parsed < 0
                              ? "0"
                              : raw;
                          setValue("price", normalized, {
                            shouldValidate: true,
                            shouldDirty: true,
                          });
                          if (
                            watch("category")?.value === 3 ||
                            (watch("category")?.value === 2 && !params?.id)
                          ) {
                            syncPricing("price", normalized);
                          } else {
                            updatePriceTaxFromAmount(normalized);
                          }
                          if (!IsBtnEnabled) setIsBtnEnabled(true);
                        }}
                        label={
                          t("price") +
                          (loggedInUserCurrency
                            ? " (" + currencyLabel + ")"
                            : "") +
                          " *"
                        }
                        placeholder={
                          t("price") +
                          (loggedInUserCurrency
                            ? " (" + currencyLabel + ")"
                            : "")
                        }
                        title={
                          t("price") +
                          (loggedInUserCurrency
                            ? " (" + currencyLabel + ")"
                            : "")
                        }
                        fullWidth
                        error={!!errors.price}
                        helperText={errors.price?.message as string}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    {watch("category")?.value === 2 ||
                    watch("category")?.value === 3 ? (
                      <Grid item xs={12} md={3}>
                        <TextField
                          type="number"
                          {...register("profitMargin")}
                          onChange={(e: any) => {
                            const raw = e.target.value;
                            if (raw === "") {
                              setValue("profitMargin", null);
                            } else {
                              const value = parseFloat(raw);
                              setValue(
                                "profitMargin",
                                value < 0 || isNaN(value) ? 0 : value,
                              );
                            }
                            syncPricing("margin");
                            if (!IsBtnEnabled) setIsBtnEnabled(true);
                          }}
                          label={
                            <Box className="flex items-center gap-1">
                              {t("profitMargin") + " (%)"}
                              <Tooltip
                                title={t("profitMarginInfo")}
                                enterDelay={0}
                                placement="top"
                                arrow
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "#fff",
                                      boxShadow: "0px 2px 8px rgba(0,0,0,0.12)",
                                      fontFamily: "Saira, sans-serif",
                                      color: "#111827",
                                      fontSize: "11px",
                                      fontWeight: "400",
                                      lineHeight: 1.5,
                                      padding: "10px",
                                    },
                                  },
                                }}
                              >
                                <InfoIcon
                                  sx={{
                                    fontSize: 17,
                                    color: "#6b7280",
                                    cursor: "pointer",
                                  }}
                                />
                              </Tooltip>
                            </Box>
                          }
                          placeholder={t("profitMargin") + " (%)"}
                          title={t("profitMargin") + " (%)"}
                          fullWidth
                          error={!!errors.profitMargin}
                          helperText={errors.profitMargin?.message as string}
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                    ) : null}
                    {watch("taxable") && watch("taxProcedureId")?.value ? (
                      <>
                        <Grid item xs={12} md={3}>
                          <TextField
                            type="number"
                            {...register("tax")}
                            label={t("tax") + " (%)"}
                            placeholder={t("tax") + " (%)"}
                            title={t("tax") + " (%)"}
                            fullWidth
                            error={!!errors.tax}
                            helperText={errors.tax?.message as string}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                              readOnly: true,
                              endAdornment: (
                                <InputAdornment position="end">
                                  <span className="font-Saira text-[13px]">
                                    {(watch("taxValue") || 0) +
                                      (loggedInUserCurrency
                                        ? " " + currencyLabel
                                        : "")}
                                  </span>
                                </InputAdornment>
                              ),
                            }}
                            value={
                              watch("taxProcedureId")?.percentageValue || 0
                            }
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <TextField
                            type="number"
                            {...register("priceWithTax")}
                            label={
                              t("priceWithTax") +
                              (loggedInUserCurrency
                                ? " (" + currencyLabel + ")"
                                : "")
                            }
                            placeholder={
                              t("priceWithTax") +
                              (loggedInUserCurrency
                                ? " (" + currencyLabel + ")"
                                : "")
                            }
                            title={
                              t("priceWithTax") +
                              (loggedInUserCurrency
                                ? " (" + currencyLabel + ")"
                                : "")
                            }
                            fullWidth
                            error={!!errors.priceWithTax}
                            helperText={errors.priceWithTax?.message as string}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e: any) => {
                              const value = parseFloat(e.target.value);
                              e.target.value = value < 0 ? 0 : value || 0;
                              const price =
                                parseFloat(e.target.value) /
                                (1 +
                                  (watch("taxProcedureId")?.percentageValue ||
                                    0) /
                                    100);
                              const priceAmount =
                                price - Math.floor(price) > 0.9
                                  ? Math.round(price)
                                  : price?.toFixed(2);
                              setValue("price", priceAmount);
                              syncPricing("price", priceAmount, {
                                skipPriceWithTax: true,
                              });
                              if (!IsBtnEnabled) setIsBtnEnabled(true);
                            }}
                          />
                        </Grid>
                      </>
                    ) : null}
                  </Grid>
                  {watch("category")?.value === 3 ? (
                    <Grid container spacing={2} className="my-[0px] ml-[3px]">
                      <Grid item xs={12}>
                        <Divider className="border-[#AEB3C4] border-1 my-[10px]" />
                        <Typography className="flex font-Saira font-[800] text-[19px] text-[#000000]">
                          {t("cost")}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={3} className="pt-0">
                        <Controller
                          name="taxableCost"
                          control={control}
                          defaultValue={false}
                          render={({ field }) => (
                            <CommonCheckbox
                              {...field}
                              label={t("isTaxableCost")}
                              onChange={(
                                event: React.ChangeEvent<HTMLInputElement>,
                              ) => {
                                field.onChange(event.target.checked);
                                if (!event.target.checked) {
                                  setValue("costTaxProcedureId", null);
                                }
                                if (!params?.id && event.target.checked)
                                  getDefaultTaxForCost();
                              }}
                              checked={field.value}
                              color={themeColors?.primary}
                            />
                          )}
                        />
                      </Grid>
                      {watch("taxableCost") ? (
                        <Grid item xs={12} md={3} className="pt-0">
                          <Controller
                            name="costTaxProcedureId"
                            control={control}
                            defaultValue={null}
                            rules={{ required: t("This field is required.") }}
                            render={({ field }) => (
                              <DynamicSelect
                                label={t("taxProcedure") + " *"}
                                {...field}
                                options={taxProcedures}
                                isSearchable
                                onChange={(selectedOption: any) => {
                                  field.onChange(selectedOption);
                                  setValue(
                                    "costtaxValue",
                                    (
                                      watch("itemCost") *
                                      (watch("costTaxProcedureId")
                                        ?.percentageValue /
                                        100)
                                    )?.toFixed(2),
                                  );
                                  setValue(
                                    "costWithTax",
                                    parseFloat(watch("itemCost")) +
                                      watch("itemCost") *
                                        (selectedOption.percentageValue / 100),
                                  );
                                }}
                                error={
                                  errors.costTaxProcedureId?.message as string
                                }
                                isLoading={
                                  searchLoading === "costtaxProcedures"
                                }
                                onInputChange={(
                                  search: string,
                                  { action }: { action: string },
                                ) => {
                                  if (
                                    action === "input-change" ||
                                    (action !== "set-value" &&
                                      action !== "menu-close" &&
                                      action !== "input-blur")
                                  )
                                    handleDropdownActions(
                                      "costtaxProcedures",
                                      "searchIt",
                                      search,
                                    );
                                  else if (
                                    action === "input-blur" ||
                                    action === "menu-close"
                                  ) {
                                    if (dropdownSearchTerm || pageNo > 1)
                                      handleDropdownActions(
                                        "costtaxProcedures",
                                        "searchIt",
                                        "",
                                      );
                                    else setDropdownSearchTerm("");
                                    setPageNo(1);
                                  }
                                }}
                                onMenuScrollToBottom={() => {
                                  if (
                                    !(taxProceduresData?.pages[0]?.data as any)
                                      .last
                                  )
                                    handleDropdownActions(
                                      "costtaxProcedures",
                                      "loadNext",
                                    );
                                }}
                                page={pageNo}
                              />
                            )}
                          />
                        </Grid>
                      ) : null}
                      <Grid item xs={12} md={3} className="pt-0">
                        <TextField
                          type="number"
                          {...register(`itemCost`, {
                            required: t("This field is required."),
                          })}
                          label={
                            t("itemCost") +
                            (loggedInUserCurrency
                              ? " (" + currencyLabel + ")"
                              : "") +
                            " *"
                          }
                          placeholder={
                            t("itemCost") +
                            (loggedInUserCurrency
                              ? " (" + currencyLabel + ")"
                              : "")
                          }
                          title={
                            t("itemCost") +
                            (loggedInUserCurrency
                              ? " (" + currencyLabel + ")"
                              : "")
                          }
                          onChange={(e: any) => {
                            const value = parseFloat(e.target.value);
                            e.target.value = value < 0 ? 0 : value || 0;
                            syncSpotPurchasePricing("cost", e.target.value);
                            if (!IsBtnEnabled) setIsBtnEnabled(true);
                          }}
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          error={!!(errors as any)?.itemCost}
                          helperText={(errors as any)?.itemCost?.message}
                          sx={{ "& .Mui-disabled": { opacity: 0.5 } }}
                        />
                      </Grid>
                      {watch("taxableCost") &&
                      watch("costTaxProcedureId")?.value ? (
                        <>
                          <Grid item xs={12} md={3} className="pt-0">
                            <TextField
                              type="number"
                              {...register("costtax")}
                              label={t("tax") + " (%)"}
                              placeholder={t("tax") + " (%)"}
                              title={t("tax") + " (%)"}
                              fullWidth
                              error={!!errors.costtax}
                              helperText={errors.costtax?.message as string}
                              InputLabelProps={{ shrink: true }}
                              InputProps={{
                                readOnly: true,
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <span className="font-Saira text-[13px]">
                                      {(watch("costtaxValue") || 0) +
                                        (loggedInUserCurrency
                                          ? " " + currencyLabel
                                          : "")}
                                    </span>
                                  </InputAdornment>
                                ),
                              }}
                              value={
                                watch("costTaxProcedureId")?.percentageValue ||
                                0
                              }
                            />
                          </Grid>
                          <Grid item xs={12} md={3} className="pt-0">
                            <TextField
                              type="number"
                              {...register("costWithTax")}
                              label={
                                t("costWithTax") +
                                (loggedInUserCurrency
                                  ? " (" + currencyLabel + ")"
                                  : "")
                              }
                              placeholder={
                                t("costWithTax") +
                                (loggedInUserCurrency
                                  ? " (" + currencyLabel + ")"
                                  : "")
                              }
                              title={
                                t("costWithTax") +
                                (loggedInUserCurrency
                                  ? " (" + currencyLabel + ")"
                                  : "")
                              }
                              fullWidth
                              error={!!errors.costWithTax}
                              helperText={errors.costWithTax?.message as string}
                              InputLabelProps={{ shrink: true }}
                              onChange={(e: any) => {
                                const value = parseFloat(e.target.value);
                                e.target.value = value < 0 ? 0 : value || 0;
                                const cost =
                                  parseFloat(e.target.value) /
                                  (1 +
                                    (watch("costTaxProcedureId")
                                      ?.percentageValue || 0) /
                                      100);
                                const itemCost =
                                  cost - Math.floor(cost) > 0.9
                                    ? Math.round(cost)
                                    : cost?.toFixed(2);
                                setValue("itemCost", itemCost);
                                syncSpotPurchasePricing("cost", itemCost);
                                if (!IsBtnEnabled) setIsBtnEnabled(true);
                              }}
                            />
                          </Grid>
                        </>
                      ) : null}
                      <Grid item xs={12} md={3} className="pt-0">
                        <Controller
                          name="sellBelowCost"
                          control={control}
                          defaultValue={false}
                          render={({ field }) => (
                            <CommonCheckbox
                              {...field}
                              label={t("sellBelowCost")}
                              onChange={(
                                event: React.ChangeEvent<HTMLInputElement>,
                              ) => {
                                field.onChange(event.target.checked);
                                if (!IsBtnEnabled) setIsBtnEnabled(true);
                              }}
                              checked={field.value}
                              color={themeColors?.primary}
                            />
                          )}
                        />
                      </Grid>
                    </Grid>
                  ) : null}
                  {watch("category")?.value === 1 ||
                  watch("category")?.value === 3 ? null : (
                    <>
                      <Grid
                        container
                        spacing={2}
                        className="my-[0px] ml-[3px] border-b  border-[#AEB3C4] pb-1"
                      >
                        <Grid item xs={12} md={3}>
                          <Controller
                            name="haveScrapItem"
                            control={control}
                            defaultValue={false}
                            render={({ field }) => (
                              <CommonCheckbox
                                {...field}
                                label={t("haveScrapItem")}
                                onChange={(
                                  event: React.ChangeEvent<HTMLInputElement>,
                                ) => {
                                  field.onChange(event.target.checked);
                                  if (!event.target.checked) {
                                    setValue("scrapItemId", null);
                                  }
                                }}
                                checked={field.value}
                                color={themeColors?.primary}
                              />
                            )}
                          />
                        </Grid>
                        {watch("haveScrapItem") ? (
                          <Grid item xs={12} md={3}>
                            <Controller
                              name="scrapItemId"
                              control={control}
                              defaultValue={null}
                              rules={{ required: t("This field is required.") }}
                              render={({ field }) => (
                                <DynamicSelect
                                  label={t("scrapItem") + " *"}
                                  {...field}
                                  options={scrapItems}
                                  isSearchable
                                  onChange={(selectedOption: any) =>
                                    field.onChange(selectedOption)
                                  }
                                  error={errors.scrapItemId?.message as string}
                                  isLoading={searchLoading === "scrapItems"}
                                  onInputChange={(
                                    search: string,
                                    { action }: { action: string },
                                  ) => {
                                    if (
                                      action === "input-change" ||
                                      (action !== "set-value" &&
                                        action !== "menu-close" &&
                                        action !== "input-blur")
                                    )
                                      handleDropdownActions(
                                        "scrapItems",
                                        "searchIt",
                                        search,
                                      );
                                    else if (
                                      action === "input-blur" ||
                                      action === "menu-close"
                                    ) {
                                      if (dropdownSearchTerm || pageNo > 1)
                                        handleDropdownActions(
                                          "scrapItems",
                                          "searchIt",
                                          "",
                                        );
                                      else setDropdownSearchTerm("");
                                      setPageNo(1);
                                    }
                                  }}
                                  onMenuScrollToBottom={() => {
                                    if (
                                      !(scrapItemsData?.pages[0]?.data as any)
                                        .last
                                    )
                                      handleDropdownActions(
                                        "scrapItems",
                                        "loadNext",
                                      );
                                  }}
                                  page={pageNo}
                                />
                              )}
                            />
                          </Grid>
                        ) : null}
                      </Grid>
                      <Grid container spacing={2} className="my-[0px] ml-[3px]">
                        {params?.id ? null : (
                          <Grid
                            item
                            xs={12}
                            className="my-[0px] ml-0"
                            sx={{ width: "100%", maxWidth: "100%" }}
                          >
                            {/* <Box style={{ paddingLeft: "16px" }}>
                              <Divider className="border-[#AEB3C4] border-1 mt-[-10px] mb-[10px]" />
                            </Box> */}
                            <Box
                              style={{ paddingLeft: "16px" }}
                              className="mb-2"
                            >
                              <Typography className="font-Saira font-[800] text-[19px] text-[#000000] text-start">
                                {t("stockInfo")}
                              </Typography>
                              <Typography className="font-Saira text-[11px] text-[#000000] text-start italic">
                                {t("enterStockInfoDetailsHere")}
                              </Typography>
                            </Box>
                            <Box
                              className="bg-white p-3 rounded-lg w-full"
                              sx={{ boxSizing: "border-box", width: "100%" }}
                            >
                              {params?.id && prevFormData?.unitId ? (
                                <>
                                  {storeItems?.map((item, index) => (
                                    <Grid
                                      container
                                      spacing={2}
                                      key={index}
                                      className="flex items-center"
                                    >
                                      {item.storeId &&
                                        item.stockQuantity !== 0 && (
                                          <>
                                            <Grid item xs={12} md={3}>
                                              <TextField
                                                {...register(
                                                  `storeItems[${index}].stockReferenceNumber`,
                                                  { required: false },
                                                )}
                                                label={t(
                                                  "stockReferenceNumber",
                                                )}
                                                placeholder={t(
                                                  "stockReferenceNumber",
                                                )}
                                                title={t(
                                                  "stockReferenceNumber",
                                                )}
                                                fullWidth
                                                disabled={
                                                  params?.id &&
                                                  prevFormData?.unitId
                                                }
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                sx={{
                                                  "& .Mui-disabled": {
                                                    opacity: 0.5,
                                                  },
                                                }}
                                              />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                              <Controller
                                                name={`storeItems[${index}].storeId`}
                                                control={control}
                                                defaultValue={item.storeId}
                                                rules={{ required: false }}
                                                render={({ field }) => (
                                                  <DynamicSelect
                                                    label={t("store")}
                                                    {...field}
                                                    options={stores}
                                                    isSearchable
                                                    isClearable
                                                    onChange={(
                                                      selectedOption: any,
                                                    ) => {
                                                      handleStoreSelect(
                                                        index,
                                                        selectedOption,
                                                      );
                                                    }}
                                                    isDisabled={
                                                      params?.id &&
                                                      prevFormData?.unitId
                                                    }
                                                    value={field.value}
                                                    error={
                                                      (errors as any)
                                                        ?.storeItems?.[index]
                                                        ?.storeId?.message
                                                    }
                                                    isLoading={
                                                      searchLoading === "stores"
                                                    }
                                                    onInputChange={(
                                                      search: string,
                                                      {
                                                        action,
                                                      }: { action: string },
                                                    ) => {
                                                      if (
                                                        action ===
                                                          "input-change" ||
                                                        (action !==
                                                          "set-value" &&
                                                          action !==
                                                            "menu-close" &&
                                                          action !==
                                                            "input-blur")
                                                      )
                                                        handleDropdownActions(
                                                          "stores",
                                                          "searchIt",
                                                          search,
                                                        );
                                                      else if (
                                                        action ===
                                                          "input-blur" ||
                                                        action === "menu-close"
                                                      ) {
                                                        if (
                                                          dropdownSearchTerm ||
                                                          pageNo > 1
                                                        )
                                                          handleDropdownActions(
                                                            "stores",
                                                            "searchIt",
                                                            "",
                                                          );
                                                        else
                                                          setDropdownSearchTerm(
                                                            "",
                                                          );
                                                        setPageNo(1);
                                                      }
                                                    }}
                                                    onMenuScrollToBottom={() => {
                                                      if (
                                                        !(
                                                          storesData?.pages[0]
                                                            ?.data as any
                                                        ).last
                                                      )
                                                        handleDropdownActions(
                                                          "stores",
                                                          "loadNext",
                                                        );
                                                    }}
                                                    page={pageNo}
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            {(isBinInventoryMode(
                                              watch(
                                                `storeItems[${index}].storeId`,
                                              )?.inventoryMode,
                                            ) ||
                                              !!watch(
                                                `storeItems[${index}].binId`,
                                              )) && (
                                              <Grid item xs={12} md={3}>
                                                <Controller
                                                  name={`storeItems[${index}].binId`}
                                                  control={control}
                                                  defaultValue={
                                                    (item as any).binId || null
                                                  }
                                                  render={({ field }) => (
                                                    <DynamicSelect
                                                      label={t("BIN")}
                                                      defaultPlaceholder="phSelectBin"
                                                      {...field}
                                                      options={
                                                        binsByStoreId[
                                                          Number(
                                                            watch(
                                                              `storeItems[${index}].storeId`,
                                                            )?.value,
                                                          )
                                                        ] || []
                                                      }
                                                      isSearchable
                                                      isClearable
                                                      onChange={(
                                                        selectedOption: any,
                                                      ) => {
                                                        field.onChange(
                                                          selectedOption,
                                                        );
                                                        if (!IsBtnEnabled)
                                                          setIsBtnEnabled(true);
                                                      }}
                                                      isDisabled={
                                                        !!(
                                                          params?.id &&
                                                          prevFormData?.unitId
                                                        )
                                                      }
                                                      value={field.value}
                                                      error={
                                                        (errors as any)
                                                          ?.storeItems?.[index]
                                                          ?.binId?.message
                                                      }
                                                      isLoading={
                                                        searchLoading ===
                                                        `bins-${
                                                          watch(
                                                            `storeItems[${index}].storeId`,
                                                          )?.value
                                                        }`
                                                      }
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                            )}
                                            <Grid item xs={12} md={3}>
                                              <TextField
                                                type="number"
                                                {...register(
                                                  `storeItems[${index}].itemCost`,
                                                  {
                                                    required: watch(
                                                      `storeItems[${index}].storeId`,
                                                    )?.value
                                                      ? t(
                                                          "This field is required.",
                                                        )
                                                      : false,
                                                  },
                                                )}
                                                onChange={(e: any) => {
                                                  const value = e.target.value;
                                                  setValue(
                                                    `storeItems[${index}].itemCost`,
                                                    value < 0 ? 0 : value || "",
                                                  );
                                                }}
                                                label={
                                                  t("itemCost") +
                                                  (watch(
                                                    `storeItems[${index}].storeId`,
                                                  )?.value
                                                    ? " *"
                                                    : "")
                                                }
                                                placeholder={
                                                  t("itemCost") +
                                                  (watch(
                                                    `storeItems[${index}].storeId`,
                                                  )?.value
                                                    ? " *"
                                                    : "")
                                                }
                                                title={
                                                  t("itemCost") +
                                                  (watch(
                                                    `storeItems[${index}].storeId`,
                                                  )?.value
                                                    ? " *"
                                                    : "")
                                                }
                                                fullWidth
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                disabled={
                                                  (params?.id &&
                                                    prevFormData?.unitId) ||
                                                  !watch(
                                                    `storeItems[${index}].storeId`,
                                                  )?.value
                                                }
                                                error={
                                                  !!(errors as any)
                                                    ?.storeItems?.[index]
                                                    ?.itemCost
                                                }
                                                helperText={
                                                  (errors as any)?.storeItems?.[
                                                    index
                                                  ]?.itemCost?.message
                                                }
                                                sx={{
                                                  "& .Mui-disabled": {
                                                    opacity: 0.5,
                                                  },
                                                }}
                                              />
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                              <TextField
                                                type="number"
                                                {...register(
                                                  `storeItems[${index}].stockQuantity`,
                                                  {
                                                    required: watch(
                                                      `storeItems[${index}].storeId`,
                                                    )?.value
                                                      ? t("required")
                                                      : false,
                                                  },
                                                )}
                                                onChange={(e: any) => {
                                                  const value = parseFloat(
                                                    e.target.value,
                                                  );
                                                  setValue(
                                                    `storeItems[${index}].stockQuantity`,
                                                    value < 0 ? 0 : value || 0,
                                                  );
                                                }}
                                                label={
                                                  t("Quantity") +
                                                  (watch(
                                                    `storeItems[${index}].storeId`,
                                                  )?.value
                                                    ? " *"
                                                    : "")
                                                }
                                                placeholder={
                                                  t("Quantity") +
                                                  (watch(
                                                    `storeItems[${index}].storeId`,
                                                  )?.value
                                                    ? " *"
                                                    : "")
                                                }
                                                title={
                                                  t("Quantity") +
                                                  (watch(
                                                    `storeItems[${index}].storeId`,
                                                  )?.value
                                                    ? " *"
                                                    : "")
                                                }
                                                fullWidth
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                disabled={
                                                  (params?.id &&
                                                    prevFormData?.unitId) ||
                                                  !watch(
                                                    `storeItems[${index}].storeId`,
                                                  )?.value
                                                }
                                                error={
                                                  !!(errors as any)
                                                    ?.storeItems?.[index]
                                                    ?.stockQuantity
                                                }
                                                helperText={
                                                  (errors as any)?.storeItems?.[
                                                    index
                                                  ]?.stockQuantity?.message
                                                }
                                                sx={{
                                                  "& .Mui-disabled": {
                                                    opacity: 0.5,
                                                  },
                                                }}
                                              />
                                            </Grid>
                                            <Grid item xs={12} md={1}>
                                              {(params?.id &&
                                                prevFormData?.unitId) ||
                                              watch("storeItems")?.length ===
                                                1 ? null : (
                                                <Tooltip title={t("delete")}>
                                                  <Button
                                                    variant="outlined"
                                                    color="error"
                                                    onClick={() =>
                                                      handleDeleteItem(index)
                                                    }
                                                    className="mt-3"
                                                  >
                                                    <RemoveIcon
                                                      fontSize="small"
                                                      sx={{ color: "#FC5C57" }}
                                                    />
                                                  </Button>
                                                </Tooltip>
                                              )}
                                            </Grid>
                                          </>
                                        )}
                                    </Grid>
                                  ))}
                                </>
                              ) : (
                                <Box
                                  sx={{
                                    width: "100%",
                                    maxWidth: "100%",
                                    minWidth: 0,
                                    boxSizing: "border-box",
                                  }}
                                >
                                  {(watch("storeItems") &&
                                  watch("storeItems").length > 0
                                    ? (
                                        watch("storeItems") ||
                                        ([] as StoreItem[])
                                      ).filter(
                                        (item: StoreItem) =>
                                          !params?.id ||
                                          (params?.id &&
                                            item.stockQuantity > 0),
                                      )
                                    : [
                                        {
                                          id: Date.now(),
                                          storeId: null,
                                          binId: null,
                                          itemCost: "",
                                          stockQuantity: 1,
                                          stockReferenceNumber: "",
                                        },
                                      ]
                                  ).map(
                                    (
                                      item: StoreItem,
                                      index: number,
                                      rows: StoreItem[],
                                    ) => (
                                      <Box
                                        key={index}
                                        className="w-full"
                                        sx={{
                                          display: "grid",
                                          width: "100%",
                                          maxWidth: "100%",
                                          minWidth: 0,
                                          boxSizing: "border-box",
                                          gap: { xs: 1.5, md: 1 },
                                          alignItems: "end",
                                          gridTemplateColumns: {
                                            xs: "minmax(0, 1fr)",
                                            md: "minmax(0, 1fr) minmax(0, 1.85fr) minmax(0, 1.45fr) minmax(0, 0.8fr) minmax(0, 0.8fr) 76px",
                                            lg: "minmax(0, 1.05fr) minmax(0, 2fr) minmax(0, 1.65fr) minmax(0, 0.9fr) minmax(0, 0.9fr) 76px",
                                          },
                                          mb: index < rows.length - 1 ? 1 : 0,
                                        }}
                                      >
                                        {/* {console.log("index====", index, item)} */}

                                        <Box
                                          sx={{
                                            minWidth: 0,
                                            width: "100%",
                                            maxWidth: "100%",
                                            overflow: "hidden",
                                          }}
                                        >
                                          <TextField
                                            {...register(
                                              `storeItems[${index}].stockReferenceNumber`,
                                              { required: false },
                                            )}
                                            label={t("stockReferenceNumber")}
                                            placeholder={t(
                                              "stockReferenceNumber",
                                            )}
                                            title={t("stockReferenceNumber")}
                                            fullWidth
                                            disabled={
                                              params?.id && prevFormData?.unitId
                                            }
                                            InputLabelProps={{ shrink: true }}
                                            sx={{
                                              "& .Mui-disabled": {
                                                opacity: 0.5,
                                              },
                                            }}
                                            onChange={() => {
                                              if (!IsBtnEnabled)
                                                setIsBtnEnabled(true);
                                            }}
                                          />
                                        </Box>
                                        <Box
                                          sx={{
                                            minWidth: 0,
                                            width: "100%",
                                            maxWidth: "100%",
                                            overflow: "hidden",
                                          }}
                                        >
                                          <Controller
                                            name={`storeItems[${index}].storeId`}
                                            control={control}
                                            defaultValue={item.storeId}
                                            rules={{ required: false }}
                                            render={({ field }) => (
                                              <DynamicSelect
                                                label={t("store")}
                                                {...field}
                                                options={getAvailableStores(
                                                  index,
                                                )} // Use filtered stores
                                                isSearchable
                                                isClearable
                                                onChange={(
                                                  selectedOption: any,
                                                ) => {
                                                  handleStoreSelect(
                                                    index,
                                                    selectedOption,
                                                  );
                                                }}
                                                isDisabled={
                                                  params?.id &&
                                                  prevFormData?.unitId
                                                }
                                                value={field.value} // Ensure the current value is shown
                                                error={
                                                  (errors as any)?.storeItems?.[
                                                    index
                                                  ]?.storeId?.message
                                                }
                                                isLoading={
                                                  searchLoading === "stores"
                                                }
                                                onInputChange={(
                                                  search: string,
                                                  {
                                                    action,
                                                  }: { action: string },
                                                ) => {
                                                  if (
                                                    action === "input-change" ||
                                                    (action !== "set-value" &&
                                                      action !== "menu-close" &&
                                                      action !== "input-blur")
                                                  )
                                                    handleDropdownActions(
                                                      "stores",
                                                      "searchIt",
                                                      search,
                                                    );
                                                  else if (
                                                    action === "input-blur" ||
                                                    action === "menu-close"
                                                  ) {
                                                    if (
                                                      dropdownSearchTerm ||
                                                      pageNo > 1
                                                    )
                                                      handleDropdownActions(
                                                        "stores",
                                                        "searchIt",
                                                        "",
                                                      );
                                                    else
                                                      setDropdownSearchTerm("");
                                                    setPageNo(1);
                                                  }
                                                }}
                                                onMenuScrollToBottom={() => {
                                                  if (
                                                    !(
                                                      storesData?.pages[0]
                                                        ?.data as any
                                                    ).last
                                                  )
                                                    handleDropdownActions(
                                                      "stores",
                                                      "loadNext",
                                                    );
                                                }}
                                                page={pageNo}
                                              />
                                            )}
                                          />
                                        </Box>
                                        <Box
                                          sx={{
                                            minWidth: 0,
                                            width: "100%",
                                            maxWidth: "100%",
                                            overflow: "hidden",
                                          }}
                                        >
                                          {(isBinInventoryMode(
                                            watch(
                                              `storeItems[${index}].storeId`,
                                            )?.inventoryMode,
                                          ) ||
                                            !!watch(
                                              `storeItems[${index}].binId`,
                                            )) && (
                                            <Controller
                                              name={`storeItems[${index}].binId`}
                                              control={control}
                                              defaultValue={
                                                (item as any).binId || null
                                              }
                                              render={({ field }) => (
                                                <DynamicSelect
                                                  label={t("BIN")}
                                                  defaultPlaceholder="phSelectBin"
                                                  {...field}
                                                  options={
                                                    binsByStoreId[
                                                      Number(
                                                        watch(
                                                          `storeItems[${index}].storeId`,
                                                        )?.value,
                                                      )
                                                    ] || []
                                                  }
                                                  isSearchable
                                                  isClearable
                                                  onChange={(
                                                    selectedOption: any,
                                                  ) => {
                                                    field.onChange(
                                                      selectedOption,
                                                    );
                                                    if (!IsBtnEnabled)
                                                      setIsBtnEnabled(true);
                                                  }}
                                                  isDisabled={
                                                    !!(
                                                      params?.id &&
                                                      prevFormData?.unitId
                                                    )
                                                  }
                                                  value={field.value}
                                                  error={
                                                    (errors as any)
                                                      ?.storeItems?.[index]
                                                      ?.binId?.message
                                                  }
                                                  isLoading={
                                                    searchLoading ===
                                                    `bins-${
                                                      watch(
                                                        `storeItems[${index}].storeId`,
                                                      )?.value
                                                    }`
                                                  }
                                                />
                                              )}
                                            />
                                          )}
                                        </Box>
                                        <Box
                                          sx={{
                                            minWidth: 0,
                                            width: "100%",
                                            maxWidth: "100%",
                                            overflow: "hidden",
                                          }}
                                        >
                                          <TextField
                                            type="number"
                                            {...register(
                                              `storeItems[${index}].itemCost`,
                                              {
                                                required: watch(
                                                  `storeItems[${index}].storeId`,
                                                )?.value
                                                  ? t("This field is required.")
                                                  : false,
                                              },
                                            )}
                                            onChange={(e: any) => {
                                              const value = e.target.value;
                                              const normalized =
                                                value < 0 ? 0 : value || "";
                                              setValue(
                                                `storeItems[${index}].itemCost`,
                                                normalized,
                                              );
                                              if (index === 0 && !params?.id) {
                                                syncInventoryPricing(
                                                  "cost",
                                                  normalized,
                                                );
                                              }
                                              if (!IsBtnEnabled)
                                                setIsBtnEnabled(true);
                                            }}
                                            label={
                                              t("itemCost") +
                                              (watch(
                                                `storeItems[${index}].storeId`,
                                              )?.value
                                                ? " *"
                                                : "")
                                            }
                                            placeholder={
                                              t("itemCost") +
                                              (watch(
                                                `storeItems[${index}].storeId`,
                                              )?.value
                                                ? " *"
                                                : "")
                                            }
                                            title={
                                              t("itemCost") +
                                              (watch(
                                                `storeItems[${index}].storeId`,
                                              )?.value
                                                ? " *"
                                                : "")
                                            }
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            disabled={
                                              (params?.id &&
                                                prevFormData?.unitId) ||
                                              !watch(
                                                `storeItems[${index}].storeId`,
                                              )?.value
                                            }
                                            error={
                                              !!(errors as any)?.storeItems?.[
                                                index
                                              ]?.itemCost
                                            }
                                            helperText={
                                              (errors as any)?.storeItems?.[
                                                index
                                              ]?.itemCost?.message
                                            }
                                            sx={{
                                              "& .Mui-disabled": {
                                                opacity: 0.5,
                                              },
                                            }}
                                          />
                                        </Box>
                                        <Box
                                          sx={{
                                            minWidth: 0,
                                            width: "100%",
                                            maxWidth: "100%",
                                            overflow: "hidden",
                                          }}
                                        >
                                          <TextField
                                            type="number"
                                            {...register(
                                              `storeItems[${index}].stockQuantity`,
                                              {
                                                required: watch(
                                                  `storeItems[${index}].storeId`,
                                                )?.value
                                                  ? t("Required")
                                                  : false,
                                              },
                                            )}
                                            onChange={(e: any) => {
                                              const value = parseFloat(
                                                e.target.value,
                                              );
                                              setValue(
                                                `storeItems[${index}].stockQuantity`,
                                                value < 0 ? 0 : value || 0,
                                              );
                                              if (!IsBtnEnabled)
                                                setIsBtnEnabled(true);
                                            }}
                                            label={
                                              t("Quantity") +
                                              (watch(
                                                `storeItems[${index}].storeId`,
                                              )?.value
                                                ? " *"
                                                : "")
                                            }
                                            placeholder={
                                              t("Quantity") +
                                              (watch(
                                                `storeItems[${index}].storeId`,
                                              )?.value
                                                ? " *"
                                                : "")
                                            }
                                            title={
                                              t("Quantity") +
                                              (watch(
                                                `storeItems[${index}].storeId`,
                                              )?.value
                                                ? " *"
                                                : "")
                                            }
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            disabled={
                                              (params?.id &&
                                                prevFormData?.unitId) ||
                                              !watch(
                                                `storeItems[${index}].storeId`,
                                              )?.value
                                            }
                                            error={
                                              !!(errors as any)?.storeItems?.[
                                                index
                                              ]?.stockQuantity
                                            }
                                            helperText={
                                              (errors as any)?.storeItems?.[
                                                index
                                              ]?.stockQuantity?.message
                                            }
                                            sx={{
                                              "& .Mui-disabled": {
                                                opacity: 0.5,
                                              },
                                            }}
                                          />
                                        </Box>
                                        <Box
                                          className="hide-on-print"
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "4px",
                                            width: 76,
                                            minWidth: 76,
                                            maxWidth: 76,
                                            flexShrink: 0,
                                            justifyContent: "flex-start",
                                          }}
                                        >
                                          <Tooltip
                                            title={t("delete")}
                                            disableHoverListener={
                                              (params?.id &&
                                                prevFormData?.unitId) ||
                                              watch("storeItems")?.length ===
                                                1 ||
                                              index === 0
                                            }
                                          >
                                            <span>
                                              <IconButton
                                                size="small"
                                                disabled={
                                                  (params?.id &&
                                                    prevFormData?.unitId) ||
                                                  watch("storeItems")
                                                    ?.length === 1 ||
                                                  index === 0
                                                }
                                                onClick={() => {
                                                  handleDeleteItem(index);
                                                  if (!IsBtnEnabled)
                                                    setIsBtnEnabled(true);
                                                }}
                                                sx={{
                                                  width: 36,
                                                  height: 36,
                                                  flexShrink: 0,
                                                  borderRadius: "8px",
                                                  bgcolor: "#4C005526",
                                                  color:
                                                    themeColors?.secondary ||
                                                    themeColors?.primary ||
                                                    "#FC5F57",
                                                  visibility:
                                                    (params?.id &&
                                                      prevFormData?.unitId) ||
                                                    watch("storeItems")
                                                      ?.length === 1 ||
                                                    index === 0
                                                      ? "hidden"
                                                      : "visible",
                                                  "&:hover": {
                                                    bgcolor: "#4C005540",
                                                  },
                                                }}
                                              >
                                                <RemoveIcon
                                                  sx={{ fontSize: 18 }}
                                                />
                                              </IconButton>
                                            </span>
                                          </Tooltip>
                                          <Tooltip
                                            title={t("Add More")}
                                            disableHoverListener={
                                              !!(
                                                params?.id &&
                                                prevFormData?.unitId
                                              ) || index !== rows.length - 1
                                            }
                                          >
                                            <span>
                                              <IconButton
                                                size="small"
                                                disabled={
                                                  !!(
                                                    params?.id &&
                                                    prevFormData?.unitId
                                                  ) || index !== rows.length - 1
                                                }
                                                onClick={handleAddMore}
                                                sx={{
                                                  width: 36,
                                                  height: 36,
                                                  flexShrink: 0,
                                                  borderRadius: "8px",
                                                  bgcolor: "#4C005526",
                                                  color:
                                                    themeColors?.primary ||
                                                    "#4C0055",
                                                  visibility:
                                                    !(
                                                      params?.id &&
                                                      prevFormData?.unitId
                                                    ) &&
                                                    index === rows.length - 1
                                                      ? "visible"
                                                      : "hidden",
                                                  "&:hover": {
                                                    bgcolor: "#4C005540",
                                                  },
                                                }}
                                              >
                                                <AddIcon
                                                  sx={{ width: 18, height: 18 }}
                                                />
                                              </IconButton>
                                            </span>
                                          </Tooltip>
                                        </Box>
                                      </Box>
                                    ),
                                  )}
                                </Box>
                              )}
                            </Box>
                          </Grid>
                        )}
                        {/* ======================   Store Items ================= */}
                        <Grid item xs={12}>
                          <Divider className="border-[#AEB3C4] border-1 mt-[10px] mb-[10px]" />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <TextField
                            type="number"
                            {...register("minPrice")}
                            onChange={(e: any) => {
                              const value = e.target.value;
                              e.target.value = value < 0 ? 0 : value || "";
                              if (!IsBtnEnabled) setIsBtnEnabled(true);
                            }}
                            label={
                              <Box className="flex items-center gap-1">
                                {t("minPrice") +
                                  (loggedInUserCurrency
                                    ? " (" + currencyLabel + ")"
                                    : "")}
                                <Tooltip
                                  title={t("minPriceInfo")}
                                  enterDelay={0}
                                  placement="top"
                                  arrow
                                  componentsProps={{
                                    tooltip: {
                                      sx: {
                                        backgroundColor: "#fff",
                                        boxShadow:
                                          "0px 2px 8px rgba(0,0,0,0.12)",
                                        fontFamily: "Saira, sans-serif",
                                        color: "#111827",
                                        fontSize: "11px",
                                        fontWeight: "400",
                                        lineHeight: 1.5,
                                        padding: "10px",
                                      },
                                    },
                                  }}
                                >
                                  <InfoIcon
                                    sx={{
                                      fontSize: 17,
                                      color: "#6b7280",
                                      cursor: "pointer",
                                    }}
                                  />
                                </Tooltip>
                              </Box>
                            }
                            placeholder={
                              t("minPrice") +
                              (loggedInUserCurrency
                                ? " (" + currencyLabel + ")"
                                : "")
                            }
                            title={
                              t("minPrice") +
                              (loggedInUserCurrency
                                ? " (" + currencyLabel + ")"
                                : "")
                            }
                            fullWidth
                            error={!!errors.minPrice}
                            helperText={errors.minPrice?.message as string}
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <TextField
                            type="number"
                            {...register("minQuantity")}
                            onChange={(e: any) => {
                              const value = e.target.value;
                              e.target.value = value < 0 ? 0 : value || "";
                              if (!IsBtnEnabled) setIsBtnEnabled(true);
                            }}
                            label={
                              <Box className="flex items-center gap-1">
                                {t("minQuantity")}
                                <Tooltip
                                  title={t("minQuantityInfo")}
                                  enterDelay={0}
                                  placement="top"
                                  arrow
                                  componentsProps={{
                                    tooltip: {
                                      sx: {
                                        backgroundColor: "#fff",
                                        boxShadow:
                                          "0px 2px 8px rgba(0,0,0,0.12)",
                                        fontFamily: "Saira, sans-serif",
                                        color: "#111827",
                                        fontSize: "11px",
                                        fontWeight: "400",
                                        lineHeight: 1.5,
                                        padding: "10px",
                                      },
                                    },
                                  }}
                                >
                                  <InfoIcon
                                    sx={{
                                      fontSize: 17,
                                      color: "#6b7280",
                                      cursor: "pointer",
                                    }}
                                  />
                                </Tooltip>
                              </Box>
                            }
                            placeholder={t("minQuantity")}
                            title={t("minQuantity")}
                            fullWidth
                            error={!!errors.minQuantity}
                            helperText={errors.minQuantity?.message as string}
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <TextField
                            type="number"
                            {...register("maxQuantity", {
                              validate: (value) => {
                                const minValue = watch("minQuantity");
                                return (
                                  !minValue ||
                                  Number(value) >= Number(minValue) ||
                                  t("maxQuantityGreater")
                                );
                              },
                            })}
                            onChange={(e: any) => {
                              const value = e.target.value;
                              e.target.value = value < 0 ? 0 : value || "";
                              if (!IsBtnEnabled) setIsBtnEnabled(true);
                            }}
                            label={
                              <Box className="flex items-center gap-1">
                                {t("maxQuantity")}
                                <Tooltip
                                  title={t("maxQuantityInfo")}
                                  enterDelay={0}
                                  placement="top"
                                  arrow
                                  componentsProps={{
                                    tooltip: {
                                      sx: {
                                        backgroundColor: "#fff",
                                        boxShadow:
                                          "0px 2px 8px rgba(0,0,0,0.12)",
                                        fontFamily: "Saira, sans-serif",
                                        color: "#111827",
                                        fontSize: "11px",
                                        fontWeight: "400",
                                        lineHeight: 1.5,
                                        padding: "10px",
                                      },
                                    },
                                  }}
                                >
                                  <InfoIcon
                                    sx={{
                                      fontSize: 17,
                                      color: "#6b7280",
                                      cursor: "pointer",
                                    }}
                                  />
                                </Tooltip>
                              </Box>
                            }
                            placeholder={t("maxQuantity")}
                            title={t("maxQuantity")}
                            fullWidth
                            error={!!errors.maxQuantity}
                            helperText={errors.maxQuantity?.message as string}
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={3}
                          className="grid"
                          sx={{
                            gridTemplateColumns: checkPrivileges(
                              "ROLE_VENDOR_CREATE",
                            )
                              ? "85% 10%"
                              : "100%",
                            "& .addNew path": { fill: themeColors?.primary },
                          }}
                        >
                          <Controller
                            name="vendorId"
                            control={control}
                            defaultValue={null}
                            rules={{ required: false }}
                            render={({ field }) => (
                              <DynamicSelect
                                label={t("vendors")}
                                {...field}
                                options={supplierOptions}
                                isSearchable
                                isClearable
                                onChange={(selectedOption: any) =>
                                  field.onChange(selectedOption)
                                }
                                error={errors.vendorId?.message as string}
                                isLoading={searchLoading === "suppliers"}
                                onInputChange={(
                                  search: string,
                                  { action }: { action: string },
                                ) => {
                                  if (
                                    action === "input-change" ||
                                    (action !== "set-value" &&
                                      action !== "menu-close" &&
                                      action !== "input-blur")
                                  )
                                    handleDropdownActions(
                                      "suppliers",
                                      "searchIt",
                                      search,
                                    );
                                  else if (
                                    action === "input-blur" ||
                                    action === "menu-close"
                                  ) {
                                    if (dropdownSearchTerm || pageNo > 1)
                                      handleDropdownActions(
                                        "suppliers",
                                        "searchIt",
                                        "",
                                      );
                                    else setDropdownSearchTerm("");
                                    setPageNo(1);
                                  }
                                }}
                                onMenuScrollToBottom={() => {
                                  if (
                                    !(vendorsData?.pages[0]?.data as any).last
                                  )
                                    handleDropdownActions(
                                      "suppliers",
                                      "loadNext",
                                    );
                                }}
                                page={pageNo}
                              />
                            )}
                          />
                          {checkPrivileges("ROLE_VENDOR_CREATE") && (
                            <Tooltip
                              onClick={() => setAddNew("vendors")}
                              title={t("addVendor")}
                            >
                              <ModalBtn className="mt-5 mx-2 mb-2 cursor-pointer h-[38px] addNew" />
                            </Tooltip>
                          )}
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <TextField
                            {...register("itemSupplierNumber")}
                            label={
                              <Box className="flex items-center gap-1">
                                {t("itemSupplierNumber")}
                                <Tooltip
                                  title={t("itemSupplierNumberInfo")}
                                  enterDelay={0}
                                  placement="top"
                                  arrow
                                  componentsProps={{
                                    tooltip: {
                                      sx: {
                                        backgroundColor: "#fff",
                                        boxShadow:
                                          "0px 2px 8px rgba(0,0,0,0.12)",
                                        fontFamily: "Saira, sans-serif",
                                        color: "#111827",
                                        fontSize: "11px",
                                        fontWeight: "400",
                                        lineHeight: 1.5,
                                        padding: "10px",
                                      },
                                    },
                                  }}
                                >
                                  <InfoIcon
                                    sx={{
                                      fontSize: 17,
                                      color: "#6b7280",
                                      cursor: "pointer",
                                    }}
                                  />
                                </Tooltip>
                              </Box>
                            }
                            placeholder={t("itemSupplierNumber")}
                            title={t("itemSupplierNumber")}
                            fullWidth
                            error={!!errors.itemSupplierNumber}
                            helperText={
                              errors.itemSupplierNumber?.message as string
                            }
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>
                        {/* <Grid item xs={12} md={3}>
                        <TextField
                          type="number"
                          {...register("warranty")}
                          label={t("warranty") + ' (' + t("Number of Days") + ')'}
                          placeholder={t("warranty") + ' (' + t("Number of Days") + ')'}
                          title={t("warranty") + ' (' + t("Number of Days") + ')'}
                          fullWidth
                          error={!!errors.warranty}
                          helperText={errors.warranty?.message as string}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e: any) => {
                            const value = e.target.value;
                            e.target.value = value < 0 ? 0 : value || "";
                            if (!IsBtnEnabled) setIsBtnEnabled(true);
                          }}
                        />
                      </Grid> */}
                        <Grid item xs={12} md={3}>
                          <TextField
                            type="number"
                            {...register("warrantyMileage")}
                            onChange={(e: any) => {
                              const value = e.target.value;
                              e.target.value = value < 0 ? 0 : value || "";
                              if (!IsBtnEnabled) setIsBtnEnabled(true);
                            }}
                            label={
                              <Box className="flex items-center gap-1">
                                {t("warrantyMileage")}
                                <Tooltip
                                  title={t("warrantyMileageInfo")}
                                  enterDelay={0}
                                  placement="top"
                                  arrow
                                  componentsProps={{
                                    tooltip: {
                                      sx: {
                                        backgroundColor: "#fff",
                                        boxShadow:
                                          "0px 2px 8px rgba(0,0,0,0.12)",
                                        fontFamily: "Saira, sans-serif",
                                        color: "#111827",
                                        fontSize: "11px",
                                        fontWeight: "400",
                                        lineHeight: 1.5,
                                        padding: "10px",
                                      },
                                    },
                                  }}
                                >
                                  <InfoIcon
                                    sx={{
                                      fontSize: 17,
                                      color: "#6b7280",
                                      cursor: "pointer",
                                    }}
                                  />
                                </Tooltip>
                              </Box>
                            }
                            placeholder={t("warrantyMileage")}
                            title={t("warrantyMileage")}
                            fullWidth
                            error={!!errors.warrantyMileage}
                            helperText={
                              errors.warrantyMileage?.message as string
                            }
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Controller
                            name="itemWarrantyServiceId"
                            control={control}
                            defaultValue={null}
                            rules={{ required: false }}
                            render={({ field }) => (
                              <DynamicSelect
                                label={t("itemWarrantyServiceId")}
                                {...field}
                                options={warrantyServices}
                                isSearchable
                                isClearable
                                onChange={(selectedOption: any) =>
                                  field.onChange(selectedOption)
                                }
                                error={
                                  errors.itemWarrantyServiceId
                                    ?.message as string
                                }
                                isLoading={searchLoading === "warrantyServices"}
                                onInputChange={(
                                  search: string,
                                  { action }: { action: string },
                                ) => {
                                  if (
                                    action === "input-change" ||
                                    (action !== "set-value" &&
                                      action !== "menu-close" &&
                                      action !== "input-blur")
                                  )
                                    handleDropdownActions(
                                      "warrantyServices",
                                      "searchIt",
                                      search,
                                    );
                                  else if (
                                    action === "input-blur" ||
                                    action === "menu-close"
                                  ) {
                                    if (dropdownSearchTerm || pageNo > 1)
                                      handleDropdownActions(
                                        "warrantyServices",
                                        "searchIt",
                                        "",
                                      );
                                    else setDropdownSearchTerm("");
                                    setPageNo(1);
                                  }
                                }}
                                onMenuScrollToBottom={() => {
                                  if (
                                    !(servicesData?.pages[0]?.data as any).last
                                  )
                                    handleDropdownActions(
                                      "warrantyServices",
                                      "loadNext",
                                    );
                                }}
                                page={pageNo}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Controller
                            name="shippingMethod"
                            control={control}
                            defaultValue={null}
                            rules={{ required: false }}
                            render={({ field }) => (
                              <DynamicSelect
                                label={t("shippingMethod")}
                                {...field}
                                options={shippingMethods}
                                isSearchable
                                isClearable
                                onChange={(selectedOption: any) =>
                                  field.onChange(selectedOption)
                                }
                                error={errors.shippingMethod?.message as string}
                              />
                            )}
                          />
                        </Grid>
                        {/* <Grid item xs={12} md={3}>
                        <TextField
                          type="number"
                          {...register("salesMarkupPercentage")}
                          onChange={() => {
                            if (!IsBtnEnabled) setIsBtnEnabled(true);
                          }}
                          label={t("salesMarkupPercentage")}
                          placeholder={t("salesMarkupPercentage")}
                          title={t("salesMarkupPercentage")}
                          fullWidth
                          error={!!errors.salesMarkupPercentage}
                          helperText={
                            errors.salesMarkupPercentage?.message as string
                          }
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid> */}
                        <Grid item xs={12} md={3}>
                          <Controller
                            name="sellBelowCost"
                            control={control}
                            defaultValue={false}
                            render={({ field }) => (
                              <CommonCheckbox
                                {...field}
                                label={t("sellBelowCost")}
                                onChange={(
                                  event: React.ChangeEvent<HTMLInputElement>,
                                ) => field.onChange(event.target.checked)}
                                checked={field.value}
                                color={themeColors?.primary}
                              />
                            )}
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={12} className="pt-0">
                        <Divider className="border-[#AEB3C4] border-1" />
                      </Grid>
                      <Grid container spacing={2} className="my-[0px] ml-[3px]">
                        <Grid item xs={12}>
                          <Typography className="flex font-Saira font-[800] text-[19px] text-[#000000]">
                            {t("frequency")}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <TextField
                            type="number"
                            {...register("itemEveryMile")}
                            onChange={(e: any) => {
                              const value = e.target.value;
                              e.target.value = value < 0 ? 0 : value || "";
                              if (!IsBtnEnabled) setIsBtnEnabled(true);
                            }}
                            label={t("Mileage (km)")}
                            placeholder={t("Mileage (km)")}
                            title={t("Mileage (km)")}
                            fullWidth
                            error={!!errors.itemEveryMile}
                            helperText={errors.itemEveryMile?.message as string}
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <TextField
                            type="number"
                            {...register("itemEveryPeriodType")}
                            onChange={(e: any) => {
                              const value = e.target.value;
                              e.target.value =
                                value < 0 ? 0 : parseInt(value) || "";
                              if (!IsBtnEnabled) setIsBtnEnabled(true);
                            }}
                            label={t("Number of Days")}
                            placeholder={t("Number of Days")}
                            title={t("Number of Days")}
                            fullWidth
                            error={!!errors.itemEveryPeriodType}
                            helperText={
                              errors.itemEveryPeriodType?.message as string
                            }
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>
                      </Grid>
                    </>
                  )}
                </Grid>
              </>
            }
          />
        )}
      </div>
    </>
  );
}
